/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.2.0 (NJsonSchema v10.1.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AppDataClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(): Promise<AppDataModel | null> {
        let url_ = this.baseUrl + "/api/v1/appData/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AppDataModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AppDataModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDataModel | null>(<any>null);
    }

    getArtistRoles(): Promise<{ [key: string]: ArtistUserRole; } | null> {
        let url_ = this.baseUrl + "/api/v1/appData/getArtistRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArtistRoles(_response);
        });
    }

    protected processGetArtistRoles(response: Response): Promise<{ [key: string]: ArtistUserRole; } | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: ArtistUserRole; } | null>(<any>null);
    }
}

export class ArtistBudgetPresetsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getInitial(artistId: string): Promise<BudgetPresetsInitialModel | null> {
        let url_ = this.baseUrl + "/api/v1/budgetpresets/getInitial?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInitial(_response);
        });
    }

    protected processGetInitial(response: Response): Promise<BudgetPresetsInitialModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BudgetPresetsInitialModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetPresetsInitialModel | null>(<any>null);
    }

    save(artistId: string, presets: BudgetPresetsModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/budgetpresets/save?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(presets);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ArtistClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(artistId: string): Promise<ArtistModel | null> {
        let url_ = this.baseUrl + "/api/v1/artists/get?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ArtistModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ArtistModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistModel | null>(<any>null);
    }

    create(model: ArtistCreateModel | null): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/artists/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    update(model: ArtistUpdateModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/artists/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAvailableReports(artistId: string): Promise<ArtistReportAvailabilityModel | null> {
        let url_ = this.baseUrl + "/api/v1/artists/getAvailableReports?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableReports(_response);
        });
    }

    protected processGetAvailableReports(response: Response): Promise<ArtistReportAvailabilityModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ArtistReportAvailabilityModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistReportAvailabilityModel | null>(<any>null);
    }

    getSummaries(): Promise<ArtistSummaryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/artists/getSummaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaries(_response);
        });
    }

    protected processGetSummaries(response: Response): Promise<ArtistSummaryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArtistSummaryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistSummaryModel[] | null>(<any>null);
    }

    removeAdminImage(artistId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/artists/removeAdminImage?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveAdminImage(_response);
        });
    }

    protected processRemoveAdminImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAvailableSubcategorys(artistId: string): Promise<CategoryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/artists/getavailablesubcategorys?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableSubcategorys(_response);
        });
    }

    protected processGetAvailableSubcategorys(response: Response): Promise<CategoryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategoryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryModel[] | null>(<any>null);
    }

    uploadImage(model: ArtistImageFileModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/artists/uploadimage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadImage(_response);
        });
    }

    protected processUploadImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @deprecated
     */
    uploadAdminImage(artistId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/artists/uploadAdminImage?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadAdminImage(_response);
        });
    }

    protected processUploadAdminImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    sendTestEmail(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/artists/sendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    sendNewArtistToDesktop(email: string | null, name: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/artists/sendSignupToDesktop?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendNewArtistToDesktop(_response);
        });
    }

    protected processSendNewArtistToDesktop(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ArtistCustomSubcategoriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getCustomSubCategories(artistId: string): Promise<CustomSubcategoryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/artistcustomsubcategories/getcustomsubcategories?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomSubCategories(_response);
        });
    }

    protected processGetCustomSubCategories(response: Response): Promise<CustomSubcategoryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomSubcategoryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomSubcategoryModel[] | null>(<any>null);
    }

    setCustomSubCategories(artistId: string, subcats: CustomSubcategoryModel[] | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/artistcustomsubcategories/setcustomsubcategories?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subcats);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCustomSubCategories(_response);
        });
    }

    protected processSetCustomSubCategories(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    extractSubcategoriesFromFile(): Promise<CustomSubcategoryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/artistcustomsubcategories/extractsubcategoriesfromfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExtractSubcategoriesFromFile(_response);
        });
    }

    protected processExtractSubcategoriesFromFile(response: Response): Promise<CustomSubcategoryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomSubcategoryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomSubcategoryModel[] | null>(<any>null);
    }
}

export class ArtistReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getArtistDashboard(artistId: string, startDateISO: string | null | undefined, endDateISO: string | null | undefined): Promise<ArtistDashBoardModel | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getArtistDashboard?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        if (startDateISO !== undefined)
            url_ += "startDateISO=" + encodeURIComponent("" + startDateISO) + "&"; 
        if (endDateISO !== undefined)
            url_ += "endDateISO=" + encodeURIComponent("" + endDateISO) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArtistDashboard(_response);
        });
    }

    protected processGetArtistDashboard(response: Response): Promise<ArtistDashBoardModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ArtistDashBoardModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistDashBoardModel | null>(<any>null);
    }

    getTourShowsReport(artistId: string, filter: TourShowsReportFilterModel | null): Promise<TourShowsReportModel | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getTourShowsReport?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourShowsReport(_response);
        });
    }

    protected processGetTourShowsReport(response: Response): Promise<TourShowsReportModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourShowsReportModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourShowsReportModel | null>(<any>null);
    }

    getArtistAverageRecommendations(artistId: string): Promise<ArtistAverageRecommendationsModel | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getArtistAverageRecommendations?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArtistAverageRecommendations(_response);
        });
    }

    protected processGetArtistAverageRecommendations(response: Response): Promise<ArtistAverageRecommendationsModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ArtistAverageRecommendationsModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistAverageRecommendationsModel | null>(<any>null);
    }
}

export class EventTrackingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    log(e: TrackingEventModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/eventtracking/track";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(e);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class FeedbackClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    sendFeedback(feedback: CustomerFeedbackModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/feedback/sendfeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedback);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendFeedback(_response);
        });
    }

    protected processSendFeedback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class HelpTipsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    hasViewed(artistId: string, tipCode: string | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/helptips/hasViewed?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        if (tipCode === undefined)
            throw new Error("The parameter 'tipCode' must be defined.");
        else
            url_ += "tipCode=" + encodeURIComponent("" + tipCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasViewed(_response);
        });
    }

    protected processHasViewed(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    reset(artistId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/helptips/reset?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReset(_response);
        });
    }

    protected processReset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    logView(tipView: HelpTutorialViewedModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/helptips/logView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tipView);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogView(_response);
        });
    }

    protected processLogView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ItineraryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @deprecated
     */
    create(model: ShowCreateModel | null): Promise<ShowModel | null> {
        let url_ = this.baseUrl + "/api/v1/itinerary/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ShowModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ShowModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShowModel | null>(<any>null);
    }

    /**
     * @deprecated
     */
    date(id: string, model: ShowDateUpdateModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/itinerary/date/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDate(_response);
        });
    }

    protected processDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param removeMissingShows (optional) 
     * @deprecated
     */
    update(tourId: string, models: ShowModel[] | null, removeMissingShows: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/itinerary/update/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        if (removeMissingShows === null)
            throw new Error("The parameter 'removeMissingShows' cannot be null.");
        else if (removeMissingShows !== undefined)
            url_ += "removeMissingShows=" + encodeURIComponent("" + removeMissingShows) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param removeMissingShows (optional) 
     * @deprecated
     */
    updateNonShow(tourId: string, models: NonShowDateModel[] | null, removeMissingShows: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/itinerary/updateNonShow/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        if (removeMissingShows === null)
            throw new Error("The parameter 'removeMissingShows' cannot be null.");
        else if (removeMissingShows !== undefined)
            url_ += "removeMissingShows=" + encodeURIComponent("" + removeMissingShows) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateNonShow(_response);
        });
    }

    protected processUpdateNonShow(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @deprecated
     */
    getAll(tourId: string): Promise<ShowModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/itinerary/getAll/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ShowModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShowModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShowModel[] | null>(<any>null);
    }

    /**
     * @deprecated
     */
    getAllDates(tourId: string): Promise<TourDatesModel | null> {
        let url_ = this.baseUrl + "/api/v1/itinerary/getAllDates/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDates(_response);
        });
    }

    protected processGetAllDates(response: Response): Promise<TourDatesModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourDatesModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourDatesModel | null>(<any>null);
    }

    /**
     * @deprecated
     */
    delete(showId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/itinerary/delete/{showId}";
        if (showId === undefined || showId === null)
            throw new Error("The parameter 'showId' must be defined.");
        url_ = url_.replace("{showId}", encodeURIComponent("" + showId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class PublicShareClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createShare(createModel: PublicShareCreateModel | null): Promise<PublicShareCreateResponseModel | null> {
        let url_ = this.baseUrl + "/api/v1/publicshare/createShare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateShare(_response);
        });
    }

    protected processCreateShare(response: Response): Promise<PublicShareCreateResponseModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PublicShareCreateResponseModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicShareCreateResponseModel | null>(<any>null);
    }

    getShareInfo(token: string, access: SharingAccessEnum): Promise<ShareInfoModel | null> {
        let url_ = this.baseUrl + "/api/v1/publicshare/getshareinfo?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        if (access === undefined || access === null)
            throw new Error("The parameter 'access' must be defined and cannot be null.");
        else
            url_ += "access=" + encodeURIComponent("" + access) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShareInfo(_response);
        });
    }

    protected processGetShareInfo(response: Response): Promise<ShareInfoModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ShareInfoModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShareInfoModel | null>(<any>null);
    }

    getTourItineraryReport(token: string): Promise<BudgetingToolInitialModel | null> {
        let url_ = this.baseUrl + "/api/v1/publicshare/gettouritineraryreport?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourItineraryReport(_response);
        });
    }

    protected processGetTourItineraryReport(response: Response): Promise<BudgetingToolInitialModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BudgetingToolInitialModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetingToolInitialModel | null>(<any>null);
    }

    getTourBudgetReport(token: string): Promise<BudgetingToolInitialModel | null> {
        let url_ = this.baseUrl + "/api/v1/publicshare/gettourbudgetreport?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourBudgetReport(_response);
        });
    }

    protected processGetTourBudgetReport(response: Response): Promise<BudgetingToolInitialModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BudgetingToolInitialModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetingToolInitialModel | null>(<any>null);
    }

    getTourFinancialsReport(token: string): Promise<TourMegaReportModel | null> {
        let url_ = this.baseUrl + "/api/v1/publicshare/gettourfinancialsreport?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourFinancialsReport(_response);
        });
    }

    protected processGetTourFinancialsReport(response: Response): Promise<TourMegaReportModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourMegaReportModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourMegaReportModel | null>(<any>null);
    }

    getTourTransactionsReport(token: string): Promise<TransactionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/publicshare/gettourtransactionsreport?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourTransactionsReport(_response);
        });
    }

    protected processGetTourTransactionsReport(response: Response): Promise<TransactionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionModel[] | null>(<any>null);
    }
}

export class QuickBooksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAuthUrl(): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/appData/getauthurl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthUrl(_response);
        });
    }

    protected processGetAuthUrl(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    getAuthTokens(code: string | null, realmId: string | null): Promise<QuickBooksAuthResponseModel | null> {
        let url_ = this.baseUrl + "/api/v1/appData/getauthtokens?";
        if (code === undefined)
            throw new Error("The parameter 'code' must be defined.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (realmId === undefined)
            throw new Error("The parameter 'realmId' must be defined.");
        else
            url_ += "realmId=" + encodeURIComponent("" + realmId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuthTokens(_response);
        });
    }

    protected processGetAuthTokens(response: Response): Promise<QuickBooksAuthResponseModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? QuickBooksAuthResponseModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuickBooksAuthResponseModel | null>(<any>null);
    }

    getTransactionData(realmId: string | null, accessToken: string | null, tourCurrencyCode: string | null): Promise<TransactionImportModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/appData/gettransactiondata?";
        if (realmId === undefined)
            throw new Error("The parameter 'realmId' must be defined.");
        else
            url_ += "realmId=" + encodeURIComponent("" + realmId) + "&"; 
        if (accessToken === undefined)
            throw new Error("The parameter 'accessToken' must be defined.");
        else
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&"; 
        if (tourCurrencyCode === undefined)
            throw new Error("The parameter 'tourCurrencyCode' must be defined.");
        else
            url_ += "tourCurrencyCode=" + encodeURIComponent("" + tourCurrencyCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransactionData(_response);
        });
    }

    protected processGetTransactionData(response: Response): Promise<TransactionImportModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionImportModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionImportModel[] | null>(<any>null);
    }
}

export class SubscriptionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getPlans(): Promise<ArtistSubscriptionPlanSummaryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/getplans";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlans(_response);
        });
    }

    protected processGetPlans(response: Response): Promise<ArtistSubscriptionPlanSummaryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArtistSubscriptionPlanSummaryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistSubscriptionPlanSummaryModel[] | null>(<any>null);
    }

    getCurrentStatus(artistId: string): Promise<ArtistSubscriptionStatusModel | null> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/getcurrentstatus?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentStatus(_response);
        });
    }

    protected processGetCurrentStatus(response: Response): Promise<ArtistSubscriptionStatusModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ArtistSubscriptionStatusModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistSubscriptionStatusModel | null>(<any>null);
    }

    addCoupon(artistId: string, code: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/addcoupon?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(code);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCoupon(_response);
        });
    }

    protected processAddCoupon(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setPlan(artistId: string, newPlan: ArtistSubscriptionSetPlanModel | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/setplan?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newPlan);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPlan(_response);
        });
    }

    protected processSetPlan(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    unsubscribe(artistId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/unsubscribe?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnsubscribe(_response);
        });
    }

    protected processUnsubscribe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    subscribe(artistId: string, model: ArtistSubscriptionSubscribeModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/subscribe?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscribe(_response);
        });
    }

    protected processSubscribe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    startTrial(artistId: string, model: ArtistSubscriptionStartTrialModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/starttrial?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartTrial(_response);
        });
    }

    protected processStartTrial(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateCreditCardToken(artistId: string, model: ArtistSubscriptionCreditCardUpdateModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/updatecreditcardtoken?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCreditCardToken(_response);
        });
    }

    protected processUpdateCreditCardToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getInvoices(artistId: string): Promise<SubscriptionInvoiceModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/getinvoices?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvoices(_response);
        });
    }

    protected processGetInvoices(response: Response): Promise<SubscriptionInvoiceModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubscriptionInvoiceModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionInvoiceModel[] | null>(<any>null);
    }

    updateBillingEmail(artistId: string, email: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/subscriptions/updatebillingemail?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBillingEmail(_response);
        });
    }

    protected processUpdateBillingEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class SuperAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    test(): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/superadmin/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    getEventsCsv(): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/superadmin/geteventscsv";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEventsCsv(_response);
        });
    }

    protected processGetEventsCsv(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    makeFreeArtist(artistId: string, code: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/superadmin/makefreeartist?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        if (code === undefined)
            throw new Error("The parameter 'code' must be defined.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMakeFreeArtist(_response);
        });
    }

    protected processMakeFreeArtist(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    removeTrialCoupon(artistId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/superadmin/removeTrialCoupon?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveTrialCoupon(_response);
        });
    }

    protected processRemoveTrialCoupon(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAllShows(): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/superadmin/allTheShows";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllShows(_response);
        });
    }

    protected processGetAllShows(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }
}

export class SystemClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getConfig(): Promise<ClientConfig | null> {
        let url_ = this.baseUrl + "/api/system/getconfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: Response): Promise<ClientConfig | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ClientConfig.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientConfig | null>(<any>null);
    }
}

export class TourBudgetClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getPresets(artistId: string): Promise<BudgetToolPresetModel | null> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/getPresets?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPresets(_response);
        });
    }

    protected processGetPresets(response: Response): Promise<BudgetToolPresetModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BudgetToolPresetModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetToolPresetModel | null>(<any>null);
    }

    getDefault(tourId: string): Promise<BudgetingToolInitialModel | null> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/getDefault?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefault(_response);
        });
    }

    protected processGetDefault(response: Response): Promise<BudgetingToolInitialModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BudgetingToolInitialModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetingToolInitialModel | null>(<any>null);
    }

    getTourBudgetSummaries(tourId: string): Promise<BudgetingToolSummaryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/list?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourBudgetSummaries(_response);
        });
    }

    protected processGetTourBudgetSummaries(response: Response): Promise<BudgetingToolSummaryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BudgetingToolSummaryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetingToolSummaryModel[] | null>(<any>null);
    }

    save(tourId: string, budget: BudgetingToolModel | null): Promise<BudgetSaveResult> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/save?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(budget);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: Response): Promise<BudgetSaveResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetSaveResult>(<any>null);
    }

    lockBudget(budgetId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/lockbudget?";
        if (budgetId === undefined || budgetId === null)
            throw new Error("The parameter 'budgetId' must be defined and cannot be null.");
        else
            url_ += "budgetId=" + encodeURIComponent("" + budgetId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLockBudget(_response);
        });
    }

    protected processLockBudget(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    addPreset(artistId: string, addPresetsModel: AddPresetsFromBudgetModel | null): Promise<string[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/addpreset?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addPresetsModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPreset(_response);
        });
    }

    protected processAddPreset(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(<any>null);
    }

    addPresetCommission(artistId: string, addPresetsModel: AddPresetCommissionsFromBudgetModel | null): Promise<string[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/addpresetcommission?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addPresetsModel);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPresetCommission(_response);
        });
    }

    protected processAddPresetCommission(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(<any>null);
    }

    addPresetPerson(artistId: string, addPresetsModels: AddPresetPersonnelFromBudgetModel[] | null): Promise<string[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/addpresetpersonnel?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addPresetsModels);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPresetPerson(_response);
        });
    }

    protected processAddPresetPerson(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(<any>null);
    }

    approve(tourId: string, model: ApproveBudgetModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/approve?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getApprovalSummaries(tourId: string): Promise<BudgetApprovalSummaryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/approvalSummaries?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApprovalSummaries(_response);
        });
    }

    protected processGetApprovalSummaries(response: Response): Promise<BudgetApprovalSummaryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BudgetApprovalSummaryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetApprovalSummaryModel[] | null>(<any>null);
    }

    getApprovalImageUrl(approvalId: string): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/tourbudgets/approvalImageUrl?";
        if (approvalId === undefined || approvalId === null)
            throw new Error("The parameter 'approvalId' must be defined and cannot be null.");
        else
            url_ += "approvalId=" + encodeURIComponent("" + approvalId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApprovalImageUrl(_response);
        });
    }

    protected processGetApprovalImageUrl(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }
}

export class TourClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(tourId: string): Promise<TourModel | null> {
        let url_ = this.baseUrl + "/api/v1/tours/get?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TourModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourModel | null>(<any>null);
    }

    create(artistId: string, model: TourCreateModel | null): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/tours/create?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    update(tourId: string, model: TourUpdateModel | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tours/update?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getSummaries(artistId: string, includeArchived: boolean | undefined): Promise<TourSummaryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tours/getSummaries?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaries(_response);
        });
    }

    protected processGetSummaries(response: Response): Promise<TourSummaryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TourSummaryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourSummaryModel[] | null>(<any>null);
    }

    getTourSummaryInfo(artistId: string, includeArchived: boolean | undefined): Promise<TourSummaryInfoModel | null> {
        let url_ = this.baseUrl + "/api/v1/tours/gettoursummaryinfo?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourSummaryInfo(_response);
        });
    }

    protected processGetTourSummaryInfo(response: Response): Promise<TourSummaryInfoModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourSummaryInfoModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourSummaryInfoModel | null>(<any>null);
    }

    archive(tourId: string, archive: boolean): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tours/archive?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        if (archive === undefined || archive === null)
            throw new Error("The parameter 'archive' must be defined and cannot be null.");
        else
            url_ += "archive=" + encodeURIComponent("" + archive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchive(_response);
        });
    }

    protected processArchive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    delete(tourId: string, archive: boolean): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tours/delete?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        if (archive === undefined || archive === null)
            throw new Error("The parameter 'archive' must be defined and cannot be null.");
        else
            url_ += "archive=" + encodeURIComponent("" + archive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAvailableReports(tourId: string): Promise<TourReportAvailabilityModel | null> {
        let url_ = this.baseUrl + "/api/v1/tours/getAvailableReports?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableReports(_response);
        });
    }

    protected processGetAvailableReports(response: Response): Promise<TourReportAvailabilityModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourReportAvailabilityModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourReportAvailabilityModel | null>(<any>null);
    }
}

export class TourFinancialsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    createFinancialsFromBudget(tourId: string, budgetId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/createFinancialsFromBudget?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        if (budgetId === undefined || budgetId === null)
            throw new Error("The parameter 'budgetId' must be defined and cannot be null.");
        else
            url_ += "budgetId=" + encodeURIComponent("" + budgetId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFinancialsFromBudget(_response);
        });
    }

    protected processCreateFinancialsFromBudget(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateItineraryFromDefaultBudget(tourId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/updateitineraryfromdefaultbudget?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateItineraryFromDefaultBudget(_response);
        });
    }

    protected processUpdateItineraryFromDefaultBudget(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    uploadTransactions(tourId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/uploadTransactions?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadTransactions(_response);
        });
    }

    protected processUploadTransactions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getTransactionShowAllocations(transactionId: string, transactionType: TransactionType): Promise<TransactionShowAllocationsModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getTransactionShowAllocations?";
        if (transactionId === undefined || transactionId === null)
            throw new Error("The parameter 'transactionId' must be defined and cannot be null.");
        else
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&"; 
        if (transactionType === undefined || transactionType === null)
            throw new Error("The parameter 'transactionType' must be defined and cannot be null.");
        else
            url_ += "transactionType=" + encodeURIComponent("" + transactionType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransactionShowAllocations(_response);
        });
    }

    protected processGetTransactionShowAllocations(response: Response): Promise<TransactionShowAllocationsModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionShowAllocationsModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionShowAllocationsModel[] | null>(<any>null);
    }

    getShowsByIncomeRatio(tourId: string): Promise<ShowIncomeRatios | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getShowsByIncomeRatio?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShowsByIncomeRatio(_response);
        });
    }

    protected processGetShowsByIncomeRatio(response: Response): Promise<ShowIncomeRatios | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ShowIncomeRatios.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShowIncomeRatios | null>(<any>null);
    }

    allocateTransactionsToShows(tourId: string, type: TransactionType, allocations: TransactionShowAllocationsUpdateModel[] | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/allocateTransactionsToShows?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allocations);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAllocateTransactionsToShows(_response);
        });
    }

    protected processAllocateTransactionsToShows(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    getTransactionCount(tourId: string): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getTransactionCount?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransactionCount(_response);
        });
    }

    protected processGetTransactionCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    getTransactionsForTourAndSubcategories(tourId: string, category: string | null, subcategory: string | null): Promise<TransactionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getTransactionsForTourAndSubcategories?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        if (category === undefined)
            throw new Error("The parameter 'category' must be defined.");
        else
            url_ += "category=" + encodeURIComponent("" + category) + "&"; 
        if (subcategory === undefined)
            throw new Error("The parameter 'subcategory' must be defined.");
        else
            url_ += "subcategory=" + encodeURIComponent("" + subcategory) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransactionsForTourAndSubcategories(_response);
        });
    }

    protected processGetTransactionsForTourAndSubcategories(response: Response): Promise<TransactionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionModel[] | null>(<any>null);
    }

    deleteTransactions(tourId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/deleteTransactionsForTour?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTransactions(_response);
        });
    }

    protected processDeleteTransactions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    importTransactions(tourId: string, transactions: TransactionImportModel[] | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/importtransactions?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactions);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportTransactions(_response);
        });
    }

    protected processImportTransactions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateShows(tourId: string, models: ShowModel[] | null, removeMissingShows: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/updateShows/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        if (removeMissingShows === null)
            throw new Error("The parameter 'removeMissingShows' cannot be null.");
        else if (removeMissingShows !== undefined)
            url_ += "removeMissingShows=" + encodeURIComponent("" + removeMissingShows) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateShows(_response);
        });
    }

    protected processUpdateShows(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateNonShows(tourId: string, models: NonShowDateModel[] | null, removeMissingShows: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/updateNonShows/{tourId}?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        if (removeMissingShows === null)
            throw new Error("The parameter 'removeMissingShows' cannot be null.");
        else if (removeMissingShows !== undefined)
            url_ += "removeMissingShows=" + encodeURIComponent("" + removeMissingShows) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateNonShows(_response);
        });
    }

    protected processUpdateNonShows(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAllShows(tourId: string): Promise<ShowModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getAllShows/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllShows(_response);
        });
    }

    protected processGetAllShows(response: Response): Promise<ShowModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShowModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShowModel[] | null>(<any>null);
    }

    getAllDates(tourId: string): Promise<TourDatesModel | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getAllDates/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDates(_response);
        });
    }

    protected processGetAllDates(response: Response): Promise<TourDatesModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourDatesModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourDatesModel | null>(<any>null);
    }

    hasDates(tourId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/hasDates/{tourId}";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined.");
        url_ = url_.replace("{tourId}", encodeURIComponent("" + tourId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasDates(_response);
        });
    }

    protected processHasDates(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getTransactionCategories(tourId: string): Promise<CategoryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getTransactionCategories?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransactionCategories(_response);
        });
    }

    protected processGetTransactionCategories(response: Response): Promise<CategoryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategoryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryModel[] | null>(<any>null);
    }

    updateSubCategoryBudgets(tourId: string, budgets: SubCategoryBudgetModel[] | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/updateSubCategoryBudgets?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(budgets);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSubCategoryBudgets(_response);
        });
    }

    protected processUpdateSubCategoryBudgets(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @deprecated
     */
    getSubCategoryBudgets(tourId: string): Promise<SubCategoryBudgetModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getSubCategoryBudgets?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubCategoryBudgets(_response);
        });
    }

    protected processGetSubCategoryBudgets(response: Response): Promise<SubCategoryBudgetModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubCategoryBudgetModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubCategoryBudgetModel[] | null>(<any>null);
    }

    getCostSubCategoryBudgets(tourId: string): Promise<SubCategoryBudgetModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getcostsubcategorybudgets?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCostSubCategoryBudgets(_response);
        });
    }

    protected processGetCostSubCategoryBudgets(response: Response): Promise<SubCategoryBudgetModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubCategoryBudgetModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubCategoryBudgetModel[] | null>(<any>null);
    }

    updateTransactionCategories(tourId: string, oldCategory: string | null, oldSubCategory: string | null, newCategory: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/updateTransactionCategories?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        if (oldCategory === undefined)
            throw new Error("The parameter 'oldCategory' must be defined.");
        else
            url_ += "oldCategory=" + encodeURIComponent("" + oldCategory) + "&"; 
        if (oldSubCategory === undefined)
            throw new Error("The parameter 'oldSubCategory' must be defined.");
        else
            url_ += "oldSubCategory=" + encodeURIComponent("" + oldSubCategory) + "&"; 
        if (newCategory === undefined)
            throw new Error("The parameter 'newCategory' must be defined.");
        else
            url_ += "newCategory=" + encodeURIComponent("" + newCategory) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTransactionCategories(_response);
        });
    }

    protected processUpdateTransactionCategories(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getCommissions(tourId: string): Promise<ActualsCommissionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getcommissions?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissions(_response);
        });
    }

    protected processGetCommissions(response: Response): Promise<ActualsCommissionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ActualsCommissionModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActualsCommissionModel[] | null>(<any>null);
    }

    saveCommissions(tourId: string, commissions: ActualsCommissionModel[] | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/savecommissions?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commissions);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveCommissions(_response);
        });
    }

    protected processSaveCommissions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getCommissionsData(tourId: string): Promise<ActualsCommissionDataModel | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getcommissionsdata?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionsData(_response);
        });
    }

    protected processGetCommissionsData(response: Response): Promise<ActualsCommissionDataModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActualsCommissionDataModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActualsCommissionDataModel | null>(<any>null);
    }

    getCommissionsFromPresets(tourId: string): Promise<ActualsCommissionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getcommissionsfrompresets?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionsFromPresets(_response);
        });
    }

    protected processGetCommissionsFromPresets(response: Response): Promise<ActualsCommissionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ActualsCommissionModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActualsCommissionModel[] | null>(<any>null);
    }

    getCommissionsFromBudget(tourId: string): Promise<ActualsCommissionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/getcommissionsfrombudget?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionsFromBudget(_response);
        });
    }

    protected processGetCommissionsFromBudget(response: Response): Promise<ActualsCommissionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ActualsCommissionModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActualsCommissionModel[] | null>(<any>null);
    }

    updateCommissionsPresets(artistId: string, commissions: ActualsCommissionModel[] | null): Promise<string[] | null> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/updatecommissionspresets?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commissions);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCommissionsPresets(_response);
        });
    }

    protected processUpdateCommissionsPresets(response: Response): Promise<string[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[] | null>(<any>null);
    }

    createCommissionsTransactions(tourId: string, adjustments: ActualsCommissionTransactionCreateModel[] | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tourfinancials/createcommissionstransactions?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(adjustments);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCommissionsTransactions(_response);
        });
    }

    protected processCreateCommissionsTransactions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TourReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getCategoryTotals(tourId: string): Promise<CategoryTotalModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getCategoryTotals?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCategoryTotals(_response);
        });
    }

    protected processGetCategoryTotals(response: Response): Promise<CategoryTotalModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategoryTotalModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryTotalModel[] | null>(<any>null);
    }

    getSubCategoryTotals(tourId: string, filter: TransactionType): Promise<SubCategoryTotalModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getSubCategoryTotals?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined and cannot be null.");
        else
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubCategoryTotals(_response);
        });
    }

    protected processGetSubCategoryTotals(response: Response): Promise<SubCategoryTotalModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubCategoryTotalModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubCategoryTotalModel[] | null>(<any>null);
    }

    getTourStats(tourId: string): Promise<TourStatsModel | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getTourStats?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourStats(_response);
        });
    }

    protected processGetTourStats(response: Response): Promise<TourStatsModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourStatsModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourStatsModel | null>(<any>null);
    }

    getTourSetupReport(tourId: string): Promise<TourSetupProgressModel | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getTourSetupReport?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourSetupReport(_response);
        });
    }

    protected processGetTourSetupReport(response: Response): Promise<TourSetupProgressModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourSetupProgressModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourSetupProgressModel | null>(<any>null);
    }

    getTourReport(tourId: string): Promise<TourMegaReportModel | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getTourReport?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTourReport(_response);
        });
    }

    protected processGetTourReport(response: Response): Promise<TourMegaReportModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TourMegaReportModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TourMegaReportModel | null>(<any>null);
    }

    getTransactions(tourId: string): Promise<TransactionModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getTransactions?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransactions(_response);
        });
    }

    protected processGetTransactions(response: Response): Promise<TransactionModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionModel[] | null>(<any>null);
    }

    getCommissionsReport(tourId: string): Promise<ActualsCommissionsReportModel | null> {
        let url_ = this.baseUrl + "/api/v1/reports/getcommissionsreport?";
        if (tourId === undefined || tourId === null)
            throw new Error("The parameter 'tourId' must be defined and cannot be null.");
        else
            url_ += "tourId=" + encodeURIComponent("" + tourId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionsReport(_response);
        });
    }

    protected processGetCommissionsReport(response: Response): Promise<ActualsCommissionsReportModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActualsCommissionsReportModel.fromJS(resultData200) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActualsCommissionsReportModel | null>(<any>null);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getList(artistId: string): Promise<ArtistUserModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/users/list?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<ArtistUserModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArtistUserModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArtistUserModel[] | null>(<any>null);
    }

    getPendingInvites(artistId: string, acceptUrl: string | null): Promise<UserArtistInviteSummaryModel[] | null> {
        let url_ = this.baseUrl + "/api/v1/users/getPendingInvites?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        if (acceptUrl === undefined)
            throw new Error("The parameter 'acceptUrl' must be defined.");
        else
            url_ += "acceptUrl=" + encodeURIComponent("" + acceptUrl) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPendingInvites(_response);
        });
    }

    protected processGetPendingInvites(response: Response): Promise<UserArtistInviteSummaryModel[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserArtistInviteSummaryModel.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserArtistInviteSummaryModel[] | null>(<any>null);
    }

    createArtistInvite(artistId: string, invite: UserInvitationCreateModel | null, acceptUrl: string | null): Promise<string | null> {
        let url_ = this.baseUrl + "/api/v1/users/createArtistInvite?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        if (acceptUrl === undefined)
            throw new Error("The parameter 'acceptUrl' must be defined.");
        else
            url_ += "acceptUrl=" + encodeURIComponent("" + acceptUrl) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invite);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateArtistInvite(_response);
        });
    }

    protected processCreateArtistInvite(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    removeArtistInvite(artistId: string, token: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/removeArtistInvite?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        if (token === undefined)
            throw new Error("The parameter 'token' must be defined.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveArtistInvite(_response);
        });
    }

    protected processRemoveArtistInvite(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    acceptArtistUserInvite(token: string | null): Promise<InviteAcceptStatus> {
        let url_ = this.baseUrl + "/api/v1/users/acceptArtistUserInvite?";
        if (token === undefined)
            throw new Error("The parameter 'token' must be defined.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcceptArtistUserInvite(_response);
        });
    }

    protected processAcceptArtistUserInvite(response: Response): Promise<InviteAcceptStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteAcceptStatus>(<any>null);
    }

    removeCurrentUser(artistId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/removeCurrentUser?";
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveCurrentUser(_response);
        });
    }

    protected processRemoveCurrentUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    removeUser(removeUserId: string | null, artistId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/removeUser?";
        if (removeUserId === undefined)
            throw new Error("The parameter 'removeUserId' must be defined.");
        else
            url_ += "removeUserId=" + encodeURIComponent("" + removeUserId) + "&"; 
        if (artistId === undefined || artistId === null)
            throw new Error("The parameter 'artistId' must be defined and cannot be null.");
        else
            url_ += "artistId=" + encodeURIComponent("" + artistId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveUser(_response);
        });
    }

    protected processRemoveUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AppDataModel implements IAppDataModel {
    currencies?: CurrencyModel[] | undefined;
    categories?: CategorySummaryModel[] | undefined;
    artistRoles?: { [key: string]: ArtistUserRole; } | undefined;
    dailyExchangeRates?: DailyExchangeRatesDayModel | undefined;

    constructor(data?: IAppDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies.push(CurrencyModel.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories.push(CategorySummaryModel.fromJS(item));
            }
            if (_data["artistRoles"]) {
                this.artistRoles = {} as any;
                for (let key in _data["artistRoles"]) {
                    if (_data["artistRoles"].hasOwnProperty(key))
                        this.artistRoles[key] = _data["artistRoles"][key];
                }
            }
            this.dailyExchangeRates = _data["dailyExchangeRates"] ? DailyExchangeRatesDayModel.fromJS(_data["dailyExchangeRates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (this.artistRoles) {
            data["artistRoles"] = {};
            for (let key in this.artistRoles) {
                if (this.artistRoles.hasOwnProperty(key))
                    data["artistRoles"][key] = this.artistRoles[key];
            }
        }
        data["dailyExchangeRates"] = this.dailyExchangeRates ? this.dailyExchangeRates.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAppDataModel {
    currencies?: CurrencyModel[] | undefined;
    categories?: CategorySummaryModel[] | undefined;
    artistRoles?: { [key: string]: ArtistUserRole; } | undefined;
    dailyExchangeRates?: DailyExchangeRatesDayModel | undefined;
}

export class CurrencyModel implements ICurrencyModel {
    symbol?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: ICurrencyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbol = _data["symbol"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CurrencyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbol"] = this.symbol;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }
}

export interface ICurrencyModel {
    symbol?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
}

export class CategorySummaryModel implements ICategorySummaryModel {
    name?: string | undefined;
    type: TransactionType;

    constructor(data?: ICategorySummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CategorySummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface ICategorySummaryModel {
    name?: string | undefined;
    type: TransactionType;
}

export enum TransactionType {
    Unknown = 0,
    Cost = 1,
    Income = 2,
}

export enum ArtistUserRole {
    MANAGER = 0,
    ARTISTMANAGER = 5,
    BUDGETMANAGER = 10,
    BOOKINGAGENT = 11,
    FINANACIALSMANAGER = 20,
    REPORTVIEWER = 50,
}

export class DailyExchangeRatesDayModel implements IDailyExchangeRatesDayModel {
    apiDate: Date;
    generatedUTC: Date;
    referenceRateCode?: string | undefined;
    rates?: DailyExchangeRateModel[] | undefined;

    constructor(data?: IDailyExchangeRatesDayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiDate = _data["apiDate"] ? new Date(_data["apiDate"].toString()) : <any>undefined;
            this.generatedUTC = _data["generatedUTC"] ? new Date(_data["generatedUTC"].toString()) : <any>undefined;
            this.referenceRateCode = _data["referenceRateCode"];
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates.push(DailyExchangeRateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyExchangeRatesDayModel {
        data = typeof data === 'object' ? data : {};
        let result = new DailyExchangeRatesDayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiDate"] = this.apiDate ? this.apiDate.toISOString() : <any>undefined;
        data["generatedUTC"] = this.generatedUTC ? this.generatedUTC.toISOString() : <any>undefined;
        data["referenceRateCode"] = this.referenceRateCode;
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDailyExchangeRatesDayModel {
    apiDate: Date;
    generatedUTC: Date;
    referenceRateCode?: string | undefined;
    rates?: DailyExchangeRateModel[] | undefined;
}

export class DailyExchangeRateModel implements IDailyExchangeRateModel {
    code?: string | undefined;
    rate: number;

    constructor(data?: IDailyExchangeRateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): DailyExchangeRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new DailyExchangeRateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["rate"] = this.rate;
        return data; 
    }
}

export interface IDailyExchangeRateModel {
    code?: string | undefined;
    rate: number;
}

export class BudgetPresetsInitialModel implements IBudgetPresetsInitialModel {
    presets?: BudgetPresetsModel | undefined;
    config?: BudgetPresetsDataModel | undefined;

    constructor(data?: IBudgetPresetsInitialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.presets = _data["presets"] ? BudgetPresetsModel.fromJS(_data["presets"]) : <any>undefined;
            this.config = _data["config"] ? BudgetPresetsDataModel.fromJS(_data["config"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BudgetPresetsInitialModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetPresetsInitialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presets"] = this.presets ? this.presets.toJSON() : <any>undefined;
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBudgetPresetsInitialModel {
    presets?: BudgetPresetsModel | undefined;
    config?: BudgetPresetsDataModel | undefined;
}

export class BudgetPresetsModel implements IBudgetPresetsModel {
    categories?: CategoryPresetModel[] | undefined;
    subcategories?: SubcategoryPresetModel[] | undefined;
    commissions?: CommissionPresetModel[] | undefined;
    personnel?: PersonnelPresetModel[] | undefined;

    constructor(data?: IBudgetPresetsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories.push(CategoryPresetModel.fromJS(item));
            }
            if (Array.isArray(_data["subcategories"])) {
                this.subcategories = [] as any;
                for (let item of _data["subcategories"])
                    this.subcategories.push(SubcategoryPresetModel.fromJS(item));
            }
            if (Array.isArray(_data["commissions"])) {
                this.commissions = [] as any;
                for (let item of _data["commissions"])
                    this.commissions.push(CommissionPresetModel.fromJS(item));
            }
            if (Array.isArray(_data["personnel"])) {
                this.personnel = [] as any;
                for (let item of _data["personnel"])
                    this.personnel.push(PersonnelPresetModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetPresetsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetPresetsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.subcategories)) {
            data["subcategories"] = [];
            for (let item of this.subcategories)
                data["subcategories"].push(item.toJSON());
        }
        if (Array.isArray(this.commissions)) {
            data["commissions"] = [];
            for (let item of this.commissions)
                data["commissions"].push(item.toJSON());
        }
        if (Array.isArray(this.personnel)) {
            data["personnel"] = [];
            for (let item of this.personnel)
                data["personnel"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBudgetPresetsModel {
    categories?: CategoryPresetModel[] | undefined;
    subcategories?: SubcategoryPresetModel[] | undefined;
    commissions?: CommissionPresetModel[] | undefined;
    personnel?: PersonnelPresetModel[] | undefined;
}

export class CategoryPresetModel implements ICategoryPresetModel {
    category?: string | undefined;
    contingency?: ContingencyPresetModel | undefined;

    constructor(data?: ICategoryPresetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.contingency = _data["contingency"] ? ContingencyPresetModel.fromJS(_data["contingency"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryPresetModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryPresetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["contingency"] = this.contingency ? this.contingency.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICategoryPresetModel {
    category?: string | undefined;
    contingency?: ContingencyPresetModel | undefined;
}

export class ContingencyPresetModel implements IContingencyPresetModel {
    percentage: number;
    deactivated: boolean;

    constructor(data?: IContingencyPresetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.deactivated = _data["deactivated"];
        }
    }

    static fromJS(data: any): ContingencyPresetModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContingencyPresetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["deactivated"] = this.deactivated;
        return data; 
    }
}

export interface IContingencyPresetModel {
    percentage: number;
    deactivated: boolean;
}

export class SubcategoryPresetModel implements ISubcategoryPresetModel {
    id: string;
    category?: string | undefined;
    subcategory?: string | undefined;
    notes?: string | undefined;
    calculation?: string | undefined;
    currencyCode?: string | undefined;
    qty: number;
    unitAmount: number;
    sequence: number;
    active: boolean;

    constructor(data?: ISubcategoryPresetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.subcategory = _data["subcategory"];
            this.notes = _data["notes"];
            this.calculation = _data["calculation"];
            this.currencyCode = _data["currencyCode"];
            this.qty = _data["qty"];
            this.unitAmount = _data["unitAmount"];
            this.sequence = _data["sequence"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SubcategoryPresetModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubcategoryPresetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["subcategory"] = this.subcategory;
        data["notes"] = this.notes;
        data["calculation"] = this.calculation;
        data["currencyCode"] = this.currencyCode;
        data["qty"] = this.qty;
        data["unitAmount"] = this.unitAmount;
        data["sequence"] = this.sequence;
        data["active"] = this.active;
        return data; 
    }
}

export interface ISubcategoryPresetModel {
    id: string;
    category?: string | undefined;
    subcategory?: string | undefined;
    notes?: string | undefined;
    calculation?: string | undefined;
    currencyCode?: string | undefined;
    qty: number;
    unitAmount: number;
    sequence: number;
    active: boolean;
}

export class CommissionPresetModel implements ICommissionPresetModel {
    id: string;
    subcategory?: string | undefined;
    defaultIncomeInclusions?: IncomePartsPresetModel | undefined;
    ratePercentage: number;
    deductibleCosts?: CommissionsPresetDeductibleCostModel[] | undefined;
    sequence: number;
    active: boolean;

    constructor(data?: ICommissionPresetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subcategory = _data["subcategory"];
            this.defaultIncomeInclusions = _data["defaultIncomeInclusions"] ? IncomePartsPresetModel.fromJS(_data["defaultIncomeInclusions"]) : <any>undefined;
            this.ratePercentage = _data["ratePercentage"];
            if (Array.isArray(_data["deductibleCosts"])) {
                this.deductibleCosts = [] as any;
                for (let item of _data["deductibleCosts"])
                    this.deductibleCosts.push(CommissionsPresetDeductibleCostModel.fromJS(item));
            }
            this.sequence = _data["sequence"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CommissionPresetModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionPresetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subcategory"] = this.subcategory;
        data["defaultIncomeInclusions"] = this.defaultIncomeInclusions ? this.defaultIncomeInclusions.toJSON() : <any>undefined;
        data["ratePercentage"] = this.ratePercentage;
        if (Array.isArray(this.deductibleCosts)) {
            data["deductibleCosts"] = [];
            for (let item of this.deductibleCosts)
                data["deductibleCosts"].push(item.toJSON());
        }
        data["sequence"] = this.sequence;
        data["active"] = this.active;
        return data; 
    }
}

export interface ICommissionPresetModel {
    id: string;
    subcategory?: string | undefined;
    defaultIncomeInclusions?: IncomePartsPresetModel | undefined;
    ratePercentage: number;
    deductibleCosts?: CommissionsPresetDeductibleCostModel[] | undefined;
    sequence: number;
    active: boolean;
}

export class IncomePartsPresetModel implements IIncomePartsPresetModel {
    performance: boolean;
    other: CommissionSubCategoriesSelectPresetEnum;
    otherSubcategoryNames?: string[] | undefined;

    constructor(data?: IIncomePartsPresetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.performance = _data["performance"];
            this.other = _data["other"];
            if (Array.isArray(_data["otherSubcategoryNames"])) {
                this.otherSubcategoryNames = [] as any;
                for (let item of _data["otherSubcategoryNames"])
                    this.otherSubcategoryNames.push(item);
            }
        }
    }

    static fromJS(data: any): IncomePartsPresetModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncomePartsPresetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["performance"] = this.performance;
        data["other"] = this.other;
        if (Array.isArray(this.otherSubcategoryNames)) {
            data["otherSubcategoryNames"] = [];
            for (let item of this.otherSubcategoryNames)
                data["otherSubcategoryNames"].push(item);
        }
        return data; 
    }
}

export interface IIncomePartsPresetModel {
    performance: boolean;
    other: CommissionSubCategoriesSelectPresetEnum;
    otherSubcategoryNames?: string[] | undefined;
}

export enum CommissionSubCategoriesSelectPresetEnum {
    All = 0,
    None = 1,
    Some = 2,
}

export class CommissionsPresetDeductibleCostModel implements ICommissionsPresetDeductibleCostModel {
    id: string;
    category?: string | undefined;
    subCategoriesSelection: CommissionSubCategoriesSelectPresetEnum;
    subcategoryNames?: string[] | undefined;

    constructor(data?: ICommissionsPresetDeductibleCostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.subCategoriesSelection = _data["subCategoriesSelection"];
            if (Array.isArray(_data["subcategoryNames"])) {
                this.subcategoryNames = [] as any;
                for (let item of _data["subcategoryNames"])
                    this.subcategoryNames.push(item);
            }
        }
    }

    static fromJS(data: any): CommissionsPresetDeductibleCostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionsPresetDeductibleCostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["subCategoriesSelection"] = this.subCategoriesSelection;
        if (Array.isArray(this.subcategoryNames)) {
            data["subcategoryNames"] = [];
            for (let item of this.subcategoryNames)
                data["subcategoryNames"].push(item);
        }
        return data; 
    }
}

export interface ICommissionsPresetDeductibleCostModel {
    id: string;
    category?: string | undefined;
    subCategoriesSelection: CommissionSubCategoriesSelectPresetEnum;
    subcategoryNames?: string[] | undefined;
}

export class PersonnelPresetModel implements IPersonnelPresetModel {
    id: string;
    name?: string | undefined;
    subcategory?: string | undefined;
    currencyCode?: string | undefined;
    sequence: number;
    active: boolean;
    archived: boolean;
    showDayRate: number;
    nonShowDayRate: number;
    mealAllowance: number;
    preTourFlatFee: number;
    payrollTax: number;

    constructor(data?: IPersonnelPresetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subcategory = _data["subcategory"];
            this.currencyCode = _data["currencyCode"];
            this.sequence = _data["sequence"];
            this.active = _data["active"];
            this.archived = _data["archived"];
            this.showDayRate = _data["showDayRate"];
            this.nonShowDayRate = _data["nonShowDayRate"];
            this.mealAllowance = _data["mealAllowance"];
            this.preTourFlatFee = _data["preTourFlatFee"];
            this.payrollTax = _data["payrollTax"];
        }
    }

    static fromJS(data: any): PersonnelPresetModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonnelPresetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subcategory"] = this.subcategory;
        data["currencyCode"] = this.currencyCode;
        data["sequence"] = this.sequence;
        data["active"] = this.active;
        data["archived"] = this.archived;
        data["showDayRate"] = this.showDayRate;
        data["nonShowDayRate"] = this.nonShowDayRate;
        data["mealAllowance"] = this.mealAllowance;
        data["preTourFlatFee"] = this.preTourFlatFee;
        data["payrollTax"] = this.payrollTax;
        return data; 
    }
}

export interface IPersonnelPresetModel {
    id: string;
    name?: string | undefined;
    subcategory?: string | undefined;
    currencyCode?: string | undefined;
    sequence: number;
    active: boolean;
    archived: boolean;
    showDayRate: number;
    nonShowDayRate: number;
    mealAllowance: number;
    preTourFlatFee: number;
    payrollTax: number;
}

export class BudgetPresetsDataModel implements IBudgetPresetsDataModel {
    categories?: CategoryModel[] | undefined;

    constructor(data?: IBudgetPresetsDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories.push(CategoryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetPresetsDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetPresetsDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBudgetPresetsDataModel {
    categories?: CategoryModel[] | undefined;
}

export class CategoryModel implements ICategoryModel {
    name?: string | undefined;
    type: TransactionType;
    subCategories?: SubCategoryModel[] | undefined;

    constructor(data?: ICategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories.push(SubCategoryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICategoryModel {
    name?: string | undefined;
    type: TransactionType;
    subCategories?: SubCategoryModel[] | undefined;
}

export class SubCategoryModel implements ISubCategoryModel {
    name?: string | undefined;
    isCustom: boolean;

    constructor(data?: ISubCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isCustom = _data["isCustom"];
        }
    }

    static fromJS(data: any): SubCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isCustom"] = this.isCustom;
        return data; 
    }
}

export interface ISubCategoryModel {
    name?: string | undefined;
    isCustom: boolean;
}

export class ArtistModel implements IArtistModel {
    id: string;
    name?: string | undefined;
    genre?: string | undefined;
    currencyCode?: string | undefined;
    notes?: string | undefined;
    hometown?: VenueModel | undefined;
    distanceUOM: DistanceUOMType;
    adminImageUrl?: string | undefined;
    showTypes?: string[] | undefined;

    constructor(data?: IArtistModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.genre = _data["genre"];
            this.currencyCode = _data["currencyCode"];
            this.notes = _data["notes"];
            this.hometown = _data["hometown"] ? VenueModel.fromJS(_data["hometown"]) : <any>undefined;
            this.distanceUOM = _data["distanceUOM"];
            this.adminImageUrl = _data["adminImageUrl"];
            if (Array.isArray(_data["showTypes"])) {
                this.showTypes = [] as any;
                for (let item of _data["showTypes"])
                    this.showTypes.push(item);
            }
        }
    }

    static fromJS(data: any): ArtistModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["genre"] = this.genre;
        data["currencyCode"] = this.currencyCode;
        data["notes"] = this.notes;
        data["hometown"] = this.hometown ? this.hometown.toJSON() : <any>undefined;
        data["distanceUOM"] = this.distanceUOM;
        data["adminImageUrl"] = this.adminImageUrl;
        if (Array.isArray(this.showTypes)) {
            data["showTypes"] = [];
            for (let item of this.showTypes)
                data["showTypes"].push(item);
        }
        return data; 
    }
}

export interface IArtistModel {
    id: string;
    name?: string | undefined;
    genre?: string | undefined;
    currencyCode?: string | undefined;
    notes?: string | undefined;
    hometown?: VenueModel | undefined;
    distanceUOM: DistanceUOMType;
    adminImageUrl?: string | undefined;
    showTypes?: string[] | undefined;
}

export class VenueModel implements IVenueModel {
    name?: string | undefined;
    locality?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateShort?: string | undefined;
    country?: string | undefined;
    countryShort?: string | undefined;
    latitude: number;
    longitude: number;

    constructor(data?: IVenueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.stateShort = _data["stateShort"];
            this.country = _data["country"];
            this.countryShort = _data["countryShort"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): VenueModel {
        data = typeof data === 'object' ? data : {};
        let result = new VenueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["state"] = this.state;
        data["stateShort"] = this.stateShort;
        data["country"] = this.country;
        data["countryShort"] = this.countryShort;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }
}

export interface IVenueModel {
    name?: string | undefined;
    locality?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateShort?: string | undefined;
    country?: string | undefined;
    countryShort?: string | undefined;
    latitude: number;
    longitude: number;
}

export enum DistanceUOMType {
    KMS = 0,
    MILES = 1,
}

export class ArtistCreateModel implements IArtistCreateModel {
    name?: string | undefined;
    currencyCode?: string | undefined;
    genre?: string | undefined;
    hometown?: VenueModel | undefined;
    distanceUOM: DistanceUOMType;
    createdByUser?: string | undefined;
    createdByUserEmail?: string | undefined;
    source?: string | undefined;
    couponCode?: string | undefined;
    presets?: SubcategoryPresetModel[] | undefined;

    constructor(data?: IArtistCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.currencyCode = _data["currencyCode"];
            this.genre = _data["genre"];
            this.hometown = _data["hometown"] ? VenueModel.fromJS(_data["hometown"]) : <any>undefined;
            this.distanceUOM = _data["distanceUOM"];
            this.createdByUser = _data["createdByUser"];
            this.createdByUserEmail = _data["createdByUserEmail"];
            this.source = _data["source"];
            this.couponCode = _data["couponCode"];
            if (Array.isArray(_data["presets"])) {
                this.presets = [] as any;
                for (let item of _data["presets"])
                    this.presets.push(SubcategoryPresetModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArtistCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["currencyCode"] = this.currencyCode;
        data["genre"] = this.genre;
        data["hometown"] = this.hometown ? this.hometown.toJSON() : <any>undefined;
        data["distanceUOM"] = this.distanceUOM;
        data["createdByUser"] = this.createdByUser;
        data["createdByUserEmail"] = this.createdByUserEmail;
        data["source"] = this.source;
        data["couponCode"] = this.couponCode;
        if (Array.isArray(this.presets)) {
            data["presets"] = [];
            for (let item of this.presets)
                data["presets"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IArtistCreateModel {
    name?: string | undefined;
    currencyCode?: string | undefined;
    genre?: string | undefined;
    hometown?: VenueModel | undefined;
    distanceUOM: DistanceUOMType;
    createdByUser?: string | undefined;
    createdByUserEmail?: string | undefined;
    source?: string | undefined;
    couponCode?: string | undefined;
    presets?: SubcategoryPresetModel[] | undefined;
}

export class ArtistUpdateModel implements IArtistUpdateModel {
    id: string;
    name?: string | undefined;
    genre?: string | undefined;
    currencyCode?: string | undefined;
    notes?: string | undefined;
    hometown?: VenueModel | undefined;
    distanceUOM: DistanceUOMType;

    constructor(data?: IArtistUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.genre = _data["genre"];
            this.currencyCode = _data["currencyCode"];
            this.notes = _data["notes"];
            this.hometown = _data["hometown"] ? VenueModel.fromJS(_data["hometown"]) : <any>undefined;
            this.distanceUOM = _data["distanceUOM"];
        }
    }

    static fromJS(data: any): ArtistUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["genre"] = this.genre;
        data["currencyCode"] = this.currencyCode;
        data["notes"] = this.notes;
        data["hometown"] = this.hometown ? this.hometown.toJSON() : <any>undefined;
        data["distanceUOM"] = this.distanceUOM;
        return data; 
    }
}

export interface IArtistUpdateModel {
    id: string;
    name?: string | undefined;
    genre?: string | undefined;
    currencyCode?: string | undefined;
    notes?: string | undefined;
    hometown?: VenueModel | undefined;
    distanceUOM: DistanceUOMType;
}

export class ArtistReportAvailabilityModel implements IArtistReportAvailabilityModel {
    artistReport: boolean;
    showSearch: boolean;

    constructor(data?: IArtistReportAvailabilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artistReport = _data["artistReport"];
            this.showSearch = _data["showSearch"];
        }
    }

    static fromJS(data: any): ArtistReportAvailabilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistReportAvailabilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artistReport"] = this.artistReport;
        data["showSearch"] = this.showSearch;
        return data; 
    }
}

export interface IArtistReportAvailabilityModel {
    artistReport: boolean;
    showSearch: boolean;
}

export class ArtistSummaryModel implements IArtistSummaryModel {
    id: string;
    name?: string | undefined;
    currencyCode?: string | undefined;
    tourCount: number;
    genre?: string | undefined;
    adminImageUrl?: string | undefined;
    hometown?: VenueModel | undefined;

    constructor(data?: IArtistSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.currencyCode = _data["currencyCode"];
            this.tourCount = _data["tourCount"];
            this.genre = _data["genre"];
            this.adminImageUrl = _data["adminImageUrl"];
            this.hometown = _data["hometown"] ? VenueModel.fromJS(_data["hometown"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArtistSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["currencyCode"] = this.currencyCode;
        data["tourCount"] = this.tourCount;
        data["genre"] = this.genre;
        data["adminImageUrl"] = this.adminImageUrl;
        data["hometown"] = this.hometown ? this.hometown.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IArtistSummaryModel {
    id: string;
    name?: string | undefined;
    currencyCode?: string | undefined;
    tourCount: number;
    genre?: string | undefined;
    adminImageUrl?: string | undefined;
    hometown?: VenueModel | undefined;
}

export class ArtistImageFileModel implements IArtistImageFileModel {
    artistId: string;
    imageData?: string | undefined;
    fileName?: string | undefined;

    constructor(data?: IArtistImageFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artistId = _data["artistId"];
            this.imageData = _data["imageData"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ArtistImageFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistImageFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artistId"] = this.artistId;
        data["imageData"] = this.imageData;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IArtistImageFileModel {
    artistId: string;
    imageData?: string | undefined;
    fileName?: string | undefined;
}

export class CustomSubcategoryModel implements ICustomSubcategoryModel {
    category?: string | undefined;
    subCategory?: string | undefined;
    exclude: boolean;

    constructor(data?: ICustomSubcategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.exclude = _data["exclude"];
        }
    }

    static fromJS(data: any): CustomSubcategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomSubcategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["exclude"] = this.exclude;
        return data; 
    }
}

export interface ICustomSubcategoryModel {
    category?: string | undefined;
    subCategory?: string | undefined;
    exclude: boolean;
}

export class ArtistDashBoardModel implements IArtistDashBoardModel {
    stats?: ArtistStatsModel | undefined;
    categoryCosts?: ArtistCostReports | undefined;
    incomeReports?: ArtistIncomeReports | undefined;

    constructor(data?: IArtistDashBoardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stats = _data["stats"] ? ArtistStatsModel.fromJS(_data["stats"]) : <any>undefined;
            this.categoryCosts = _data["categoryCosts"] ? ArtistCostReports.fromJS(_data["categoryCosts"]) : <any>undefined;
            this.incomeReports = _data["incomeReports"] ? ArtistIncomeReports.fromJS(_data["incomeReports"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArtistDashBoardModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistDashBoardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        data["categoryCosts"] = this.categoryCosts ? this.categoryCosts.toJSON() : <any>undefined;
        data["incomeReports"] = this.incomeReports ? this.incomeReports.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IArtistDashBoardModel {
    stats?: ArtistStatsModel | undefined;
    categoryCosts?: ArtistCostReports | undefined;
    incomeReports?: ArtistIncomeReports | undefined;
}

export class ArtistStatsModel implements IArtistStatsModel {
    ticketsSold: number;
    tourCount: number;
    showCount: number;
    merchIncomePerHead: number;
    financials?: ArtistCurrencyStatsModel | undefined;

    constructor(data?: IArtistStatsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketsSold = _data["ticketsSold"];
            this.tourCount = _data["tourCount"];
            this.showCount = _data["showCount"];
            this.merchIncomePerHead = _data["merchIncomePerHead"];
            this.financials = _data["financials"] ? ArtistCurrencyStatsModel.fromJS(_data["financials"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArtistStatsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistStatsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketsSold"] = this.ticketsSold;
        data["tourCount"] = this.tourCount;
        data["showCount"] = this.showCount;
        data["merchIncomePerHead"] = this.merchIncomePerHead;
        data["financials"] = this.financials ? this.financials.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IArtistStatsModel {
    ticketsSold: number;
    tourCount: number;
    showCount: number;
    merchIncomePerHead: number;
    financials?: ArtistCurrencyStatsModel | undefined;
}

export class ArtistCurrencyStatsModel implements IArtistCurrencyStatsModel {
    currencyCode?: string | undefined;
    currencySymbol?: string | undefined;
    totalIncome: number;
    totalTourIncome: number;
    totalMerchIncome: number;
    totalCosts: number;
    totalTourCosts: number;
    totalMerchCosts: number;
    totalProfit: number;
    totalTourProfit: number;
    totalMerchProfit: number;

    constructor(data?: IArtistCurrencyStatsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.currencySymbol = _data["currencySymbol"];
            this.totalIncome = _data["totalIncome"];
            this.totalTourIncome = _data["totalTourIncome"];
            this.totalMerchIncome = _data["totalMerchIncome"];
            this.totalCosts = _data["totalCosts"];
            this.totalTourCosts = _data["totalTourCosts"];
            this.totalMerchCosts = _data["totalMerchCosts"];
            this.totalProfit = _data["totalProfit"];
            this.totalTourProfit = _data["totalTourProfit"];
            this.totalMerchProfit = _data["totalMerchProfit"];
        }
    }

    static fromJS(data: any): ArtistCurrencyStatsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistCurrencyStatsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["currencySymbol"] = this.currencySymbol;
        data["totalIncome"] = this.totalIncome;
        data["totalTourIncome"] = this.totalTourIncome;
        data["totalMerchIncome"] = this.totalMerchIncome;
        data["totalCosts"] = this.totalCosts;
        data["totalTourCosts"] = this.totalTourCosts;
        data["totalMerchCosts"] = this.totalMerchCosts;
        data["totalProfit"] = this.totalProfit;
        data["totalTourProfit"] = this.totalTourProfit;
        data["totalMerchProfit"] = this.totalMerchProfit;
        return data; 
    }
}

export interface IArtistCurrencyStatsModel {
    currencyCode?: string | undefined;
    currencySymbol?: string | undefined;
    totalIncome: number;
    totalTourIncome: number;
    totalMerchIncome: number;
    totalCosts: number;
    totalTourCosts: number;
    totalMerchCosts: number;
    totalProfit: number;
    totalTourProfit: number;
    totalMerchProfit: number;
}

export class ArtistCostReports implements IArtistCostReports {
    allCategories?: ArtistCostReportModel | undefined;
    byShowType?: ArtistCategoryRatioOfIncomeReport[] | undefined;
    byCountry?: ArtistCategoryRatioOfIncomeReport[] | undefined;

    constructor(data?: IArtistCostReports) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allCategories = _data["allCategories"] ? ArtistCostReportModel.fromJS(_data["allCategories"]) : <any>undefined;
            if (Array.isArray(_data["byShowType"])) {
                this.byShowType = [] as any;
                for (let item of _data["byShowType"])
                    this.byShowType.push(ArtistCategoryRatioOfIncomeReport.fromJS(item));
            }
            if (Array.isArray(_data["byCountry"])) {
                this.byCountry = [] as any;
                for (let item of _data["byCountry"])
                    this.byCountry.push(ArtistCategoryRatioOfIncomeReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArtistCostReports {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistCostReports();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allCategories"] = this.allCategories ? this.allCategories.toJSON() : <any>undefined;
        if (Array.isArray(this.byShowType)) {
            data["byShowType"] = [];
            for (let item of this.byShowType)
                data["byShowType"].push(item.toJSON());
        }
        if (Array.isArray(this.byCountry)) {
            data["byCountry"] = [];
            for (let item of this.byCountry)
                data["byCountry"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IArtistCostReports {
    allCategories?: ArtistCostReportModel | undefined;
    byShowType?: ArtistCategoryRatioOfIncomeReport[] | undefined;
    byCountry?: ArtistCategoryRatioOfIncomeReport[] | undefined;
}

export class ArtistCostReportModel implements IArtistCostReportModel {
    categoryCosts?: ArtistCategoryCostRow[] | undefined;
    categoryProfitTotals?: ArtistCategoryCostRow[] | undefined;

    constructor(data?: IArtistCostReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categoryCosts"])) {
                this.categoryCosts = [] as any;
                for (let item of _data["categoryCosts"])
                    this.categoryCosts.push(ArtistCategoryCostRow.fromJS(item));
            }
            if (Array.isArray(_data["categoryProfitTotals"])) {
                this.categoryProfitTotals = [] as any;
                for (let item of _data["categoryProfitTotals"])
                    this.categoryProfitTotals.push(ArtistCategoryCostRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArtistCostReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistCostReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categoryCosts)) {
            data["categoryCosts"] = [];
            for (let item of this.categoryCosts)
                data["categoryCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryProfitTotals)) {
            data["categoryProfitTotals"] = [];
            for (let item of this.categoryProfitTotals)
                data["categoryProfitTotals"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IArtistCostReportModel {
    categoryCosts?: ArtistCategoryCostRow[] | undefined;
    categoryProfitTotals?: ArtistCategoryCostRow[] | undefined;
}

export class ArtistCategoryCostRow implements IArtistCategoryCostRow {
    currencyCode?: string | undefined;
    currencySymbol?: string | undefined;
    category?: string | undefined;
    amount: number;
    ratioOfIncome: number;
    ratioOfArtistAverage: number;

    constructor(data?: IArtistCategoryCostRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.currencySymbol = _data["currencySymbol"];
            this.category = _data["category"];
            this.amount = _data["amount"];
            this.ratioOfIncome = _data["ratioOfIncome"];
            this.ratioOfArtistAverage = _data["ratioOfArtistAverage"];
        }
    }

    static fromJS(data: any): ArtistCategoryCostRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistCategoryCostRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["currencySymbol"] = this.currencySymbol;
        data["category"] = this.category;
        data["amount"] = this.amount;
        data["ratioOfIncome"] = this.ratioOfIncome;
        data["ratioOfArtistAverage"] = this.ratioOfArtistAverage;
        return data; 
    }
}

export interface IArtistCategoryCostRow {
    currencyCode?: string | undefined;
    currencySymbol?: string | undefined;
    category?: string | undefined;
    amount: number;
    ratioOfIncome: number;
    ratioOfArtistAverage: number;
}

export class ArtistCategoryRatioOfIncomeReport implements IArtistCategoryRatioOfIncomeReport {
    category?: string | undefined;
    rows?: ArtistCategoryRatioOfIncomeReportRow[] | undefined;

    constructor(data?: IArtistCategoryRatioOfIncomeReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows.push(ArtistCategoryRatioOfIncomeReportRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArtistCategoryRatioOfIncomeReport {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistCategoryRatioOfIncomeReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IArtistCategoryRatioOfIncomeReport {
    category?: string | undefined;
    rows?: ArtistCategoryRatioOfIncomeReportRow[] | undefined;
}

export class ArtistCategoryRatioOfIncomeReportRow implements IArtistCategoryRatioOfIncomeReportRow {
    name?: string | undefined;
    ratioOfIncome: number;
    ratioOfTourIncome: number;

    constructor(data?: IArtistCategoryRatioOfIncomeReportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ratioOfIncome = _data["ratioOfIncome"];
            this.ratioOfTourIncome = _data["ratioOfTourIncome"];
        }
    }

    static fromJS(data: any): ArtistCategoryRatioOfIncomeReportRow {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistCategoryRatioOfIncomeReportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ratioOfIncome"] = this.ratioOfIncome;
        data["ratioOfTourIncome"] = this.ratioOfTourIncome;
        return data; 
    }
}

export interface IArtistCategoryRatioOfIncomeReportRow {
    name?: string | undefined;
    ratioOfIncome: number;
    ratioOfTourIncome: number;
}

export class ArtistIncomeReports implements IArtistIncomeReports {
    byShowType?: ArtistIncomeReportModel | undefined;
    byCountry?: ArtistIncomeReportModel | undefined;
    byState?: ArtistIncomeReportModel | undefined;
    byCity?: ArtistIncomeReportModel | undefined;

    constructor(data?: IArtistIncomeReports) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.byShowType = _data["byShowType"] ? ArtistIncomeReportModel.fromJS(_data["byShowType"]) : <any>undefined;
            this.byCountry = _data["byCountry"] ? ArtistIncomeReportModel.fromJS(_data["byCountry"]) : <any>undefined;
            this.byState = _data["byState"] ? ArtistIncomeReportModel.fromJS(_data["byState"]) : <any>undefined;
            this.byCity = _data["byCity"] ? ArtistIncomeReportModel.fromJS(_data["byCity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArtistIncomeReports {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistIncomeReports();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["byShowType"] = this.byShowType ? this.byShowType.toJSON() : <any>undefined;
        data["byCountry"] = this.byCountry ? this.byCountry.toJSON() : <any>undefined;
        data["byState"] = this.byState ? this.byState.toJSON() : <any>undefined;
        data["byCity"] = this.byCity ? this.byCity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IArtistIncomeReports {
    byShowType?: ArtistIncomeReportModel | undefined;
    byCountry?: ArtistIncomeReportModel | undefined;
    byState?: ArtistIncomeReportModel | undefined;
    byCity?: ArtistIncomeReportModel | undefined;
}

export class ArtistIncomeReportModel implements IArtistIncomeReportModel {
    reportType?: string | undefined;
    stats?: ArtistIncomeStatModel[] | undefined;
    totals?: ArtistIncomeStatModel | undefined;

    constructor(data?: IArtistIncomeReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportType = _data["reportType"];
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats.push(ArtistIncomeStatModel.fromJS(item));
            }
            this.totals = _data["totals"] ? ArtistIncomeStatModel.fromJS(_data["totals"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArtistIncomeReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistIncomeReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportType"] = this.reportType;
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IArtistIncomeReportModel {
    reportType?: string | undefined;
    stats?: ArtistIncomeStatModel[] | undefined;
    totals?: ArtistIncomeStatModel | undefined;
}

export class ArtistIncomeStatModel implements IArtistIncomeStatModel {
    name?: string | undefined;
    showCount: number;
    ticketsSold: number;
    currencyCode?: string | undefined;
    currencySymbol?: string | undefined;
    cost: number;
    tourCost: number;
    income: number;
    tourIncome: number;
    incomeRatioOfTotal: number;
    tourIncomeRatioOfTotal: number;
    merchCost: number;
    merchSales: number;
    merchIncome: number;
    merchProfit: number;
    merchSalesPerHead: number;
    profit: number;
    profitMarginRatio: number;
    tourProfit: number;
    tourProfitMarginRatio: number;

    constructor(data?: IArtistIncomeStatModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.showCount = _data["showCount"];
            this.ticketsSold = _data["ticketsSold"];
            this.currencyCode = _data["currencyCode"];
            this.currencySymbol = _data["currencySymbol"];
            this.cost = _data["cost"];
            this.tourCost = _data["tourCost"];
            this.income = _data["income"];
            this.tourIncome = _data["tourIncome"];
            this.incomeRatioOfTotal = _data["incomeRatioOfTotal"];
            this.tourIncomeRatioOfTotal = _data["tourIncomeRatioOfTotal"];
            this.merchCost = _data["merchCost"];
            this.merchSales = _data["merchSales"];
            this.merchIncome = _data["merchIncome"];
            this.merchProfit = _data["merchProfit"];
            this.merchSalesPerHead = _data["merchSalesPerHead"];
            this.profit = _data["profit"];
            this.profitMarginRatio = _data["profitMarginRatio"];
            this.tourProfit = _data["tourProfit"];
            this.tourProfitMarginRatio = _data["tourProfitMarginRatio"];
        }
    }

    static fromJS(data: any): ArtistIncomeStatModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistIncomeStatModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["showCount"] = this.showCount;
        data["ticketsSold"] = this.ticketsSold;
        data["currencyCode"] = this.currencyCode;
        data["currencySymbol"] = this.currencySymbol;
        data["cost"] = this.cost;
        data["tourCost"] = this.tourCost;
        data["income"] = this.income;
        data["tourIncome"] = this.tourIncome;
        data["incomeRatioOfTotal"] = this.incomeRatioOfTotal;
        data["tourIncomeRatioOfTotal"] = this.tourIncomeRatioOfTotal;
        data["merchCost"] = this.merchCost;
        data["merchSales"] = this.merchSales;
        data["merchIncome"] = this.merchIncome;
        data["merchProfit"] = this.merchProfit;
        data["merchSalesPerHead"] = this.merchSalesPerHead;
        data["profit"] = this.profit;
        data["profitMarginRatio"] = this.profitMarginRatio;
        data["tourProfit"] = this.tourProfit;
        data["tourProfitMarginRatio"] = this.tourProfitMarginRatio;
        return data; 
    }
}

export interface IArtistIncomeStatModel {
    name?: string | undefined;
    showCount: number;
    ticketsSold: number;
    currencyCode?: string | undefined;
    currencySymbol?: string | undefined;
    cost: number;
    tourCost: number;
    income: number;
    tourIncome: number;
    incomeRatioOfTotal: number;
    tourIncomeRatioOfTotal: number;
    merchCost: number;
    merchSales: number;
    merchIncome: number;
    merchProfit: number;
    merchSalesPerHead: number;
    profit: number;
    profitMarginRatio: number;
    tourProfit: number;
    tourProfitMarginRatio: number;
}

export class TourShowsReportModel implements ITourShowsReportModel {
    filterValues?: TourShowsReportValuesModel | undefined;
    tourCount: number;
    showCount: number;
    totalProfit: number;
    totalCosts: number;
    totalIncome: number;
    shows?: TourShowsReportShowModel[] | undefined;
    currency?: CurrencyModel | undefined;

    constructor(data?: ITourShowsReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterValues = _data["filterValues"] ? TourShowsReportValuesModel.fromJS(_data["filterValues"]) : <any>undefined;
            this.tourCount = _data["tourCount"];
            this.showCount = _data["showCount"];
            this.totalProfit = _data["totalProfit"];
            this.totalCosts = _data["totalCosts"];
            this.totalIncome = _data["totalIncome"];
            if (Array.isArray(_data["shows"])) {
                this.shows = [] as any;
                for (let item of _data["shows"])
                    this.shows.push(TourShowsReportShowModel.fromJS(item));
            }
            this.currency = _data["currency"] ? CurrencyModel.fromJS(_data["currency"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TourShowsReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourShowsReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterValues"] = this.filterValues ? this.filterValues.toJSON() : <any>undefined;
        data["tourCount"] = this.tourCount;
        data["showCount"] = this.showCount;
        data["totalProfit"] = this.totalProfit;
        data["totalCosts"] = this.totalCosts;
        data["totalIncome"] = this.totalIncome;
        if (Array.isArray(this.shows)) {
            data["shows"] = [];
            for (let item of this.shows)
                data["shows"].push(item.toJSON());
        }
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITourShowsReportModel {
    filterValues?: TourShowsReportValuesModel | undefined;
    tourCount: number;
    showCount: number;
    totalProfit: number;
    totalCosts: number;
    totalIncome: number;
    shows?: TourShowsReportShowModel[] | undefined;
    currency?: CurrencyModel | undefined;
}

export class TourShowsReportValuesModel implements ITourShowsReportValuesModel {
    countries?: string[] | undefined;
    showTypes?: string[] | undefined;

    constructor(data?: ITourShowsReportValuesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries.push(item);
            }
            if (Array.isArray(_data["showTypes"])) {
                this.showTypes = [] as any;
                for (let item of _data["showTypes"])
                    this.showTypes.push(item);
            }
        }
    }

    static fromJS(data: any): TourShowsReportValuesModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourShowsReportValuesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.showTypes)) {
            data["showTypes"] = [];
            for (let item of this.showTypes)
                data["showTypes"].push(item);
        }
        return data; 
    }
}

export interface ITourShowsReportValuesModel {
    countries?: string[] | undefined;
    showTypes?: string[] | undefined;
}

export class TourShowsReportShowModel implements ITourShowsReportShowModel {
    info?: ShowValueInfoModel | undefined;
    dateISO?: string | undefined;
    venue?: VenueModel | undefined;
    showType?: string | undefined;
    tourId: string;
    showId: string;
    tourName?: string | undefined;
    ticketSell: number;
    merchSoldAmount: number;
    merchSoldPerHeadAmount: number;
    incomeTotal: number;
    costsTotal: number;
    profitTotal: number;
    marginRatio: number;

    constructor(data?: ITourShowsReportShowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] ? ShowValueInfoModel.fromJS(_data["info"]) : <any>undefined;
            this.dateISO = _data["dateISO"];
            this.venue = _data["venue"] ? VenueModel.fromJS(_data["venue"]) : <any>undefined;
            this.showType = _data["showType"];
            this.tourId = _data["tourId"];
            this.showId = _data["showId"];
            this.tourName = _data["tourName"];
            this.ticketSell = _data["ticketSell"];
            this.merchSoldAmount = _data["merchSoldAmount"];
            this.merchSoldPerHeadAmount = _data["merchSoldPerHeadAmount"];
            this.incomeTotal = _data["incomeTotal"];
            this.costsTotal = _data["costsTotal"];
            this.profitTotal = _data["profitTotal"];
            this.marginRatio = _data["marginRatio"];
        }
    }

    static fromJS(data: any): TourShowsReportShowModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourShowsReportShowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        data["dateISO"] = this.dateISO;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        data["showType"] = this.showType;
        data["tourId"] = this.tourId;
        data["showId"] = this.showId;
        data["tourName"] = this.tourName;
        data["ticketSell"] = this.ticketSell;
        data["merchSoldAmount"] = this.merchSoldAmount;
        data["merchSoldPerHeadAmount"] = this.merchSoldPerHeadAmount;
        data["incomeTotal"] = this.incomeTotal;
        data["costsTotal"] = this.costsTotal;
        data["profitTotal"] = this.profitTotal;
        data["marginRatio"] = this.marginRatio;
        return data; 
    }
}

export interface ITourShowsReportShowModel {
    info?: ShowValueInfoModel | undefined;
    dateISO?: string | undefined;
    venue?: VenueModel | undefined;
    showType?: string | undefined;
    tourId: string;
    showId: string;
    tourName?: string | undefined;
    ticketSell: number;
    merchSoldAmount: number;
    merchSoldPerHeadAmount: number;
    incomeTotal: number;
    costsTotal: number;
    profitTotal: number;
    marginRatio: number;
}

export class ShowValueInfoModel implements IShowValueInfoModel {
    dateISO?: string | undefined;
    venue?: VenueModel | undefined;

    constructor(data?: IShowValueInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateISO = _data["dateISO"];
            this.venue = _data["venue"] ? VenueModel.fromJS(_data["venue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShowValueInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShowValueInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateISO"] = this.dateISO;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IShowValueInfoModel {
    dateISO?: string | undefined;
    venue?: VenueModel | undefined;
}

export class TourShowsReportFilterModel implements ITourShowsReportFilterModel {
    startShowDateISO?: string | undefined;
    endShowDateISO?: string | undefined;
    country?: string | undefined;
    showType?: string | undefined;
    currencyCode?: string | undefined;

    constructor(data?: ITourShowsReportFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startShowDateISO = _data["startShowDateISO"];
            this.endShowDateISO = _data["endShowDateISO"];
            this.country = _data["country"];
            this.showType = _data["showType"];
            this.currencyCode = _data["currencyCode"];
        }
    }

    static fromJS(data: any): TourShowsReportFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourShowsReportFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startShowDateISO"] = this.startShowDateISO;
        data["endShowDateISO"] = this.endShowDateISO;
        data["country"] = this.country;
        data["showType"] = this.showType;
        data["currencyCode"] = this.currencyCode;
        return data; 
    }
}

export interface ITourShowsReportFilterModel {
    startShowDateISO?: string | undefined;
    endShowDateISO?: string | undefined;
    country?: string | undefined;
    showType?: string | undefined;
    currencyCode?: string | undefined;
}

export class ArtistAverageRecommendationsModel implements IArtistAverageRecommendationsModel {
    costs?: ArtistCostReportModel | undefined;
    stats?: ArtistStatsModel | undefined;

    constructor(data?: IArtistAverageRecommendationsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costs = _data["costs"] ? ArtistCostReportModel.fromJS(_data["costs"]) : <any>undefined;
            this.stats = _data["stats"] ? ArtistStatsModel.fromJS(_data["stats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArtistAverageRecommendationsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistAverageRecommendationsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costs"] = this.costs ? this.costs.toJSON() : <any>undefined;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IArtistAverageRecommendationsModel {
    costs?: ArtistCostReportModel | undefined;
    stats?: ArtistStatsModel | undefined;
}

export class TrackingEventModel implements ITrackingEventModel {
    name?: string | undefined;
    email?: string | undefined;
    artistId?: string | undefined;
    artistName?: string | undefined;
    tourId?: string | undefined;
    tourName?: string | undefined;
    notes?: string | undefined;

    constructor(data?: ITrackingEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.artistId = _data["artistId"];
            this.artistName = _data["artistName"];
            this.tourId = _data["tourId"];
            this.tourName = _data["tourName"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): TrackingEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingEventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["artistId"] = this.artistId;
        data["artistName"] = this.artistName;
        data["tourId"] = this.tourId;
        data["tourName"] = this.tourName;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface ITrackingEventModel {
    name?: string | undefined;
    email?: string | undefined;
    artistId?: string | undefined;
    artistName?: string | undefined;
    tourId?: string | undefined;
    tourName?: string | undefined;
    notes?: string | undefined;
}

export class CustomerFeedbackModel implements ICustomerFeedbackModel {
    name?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    message?: string | undefined;

    constructor(data?: ICustomerFeedbackModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.url = _data["url"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CustomerFeedbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFeedbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["url"] = this.url;
        data["message"] = this.message;
        return data; 
    }
}

export interface ICustomerFeedbackModel {
    name?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    message?: string | undefined;
}

export class HelpTutorialViewedModel implements IHelpTutorialViewedModel {
    artistId: string;
    tipCode?: string | undefined;

    constructor(data?: IHelpTutorialViewedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artistId = _data["artistId"];
            this.tipCode = _data["tipCode"];
        }
    }

    static fromJS(data: any): HelpTutorialViewedModel {
        data = typeof data === 'object' ? data : {};
        let result = new HelpTutorialViewedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artistId"] = this.artistId;
        data["tipCode"] = this.tipCode;
        return data; 
    }
}

export interface IHelpTutorialViewedModel {
    artistId: string;
    tipCode?: string | undefined;
}

export class ShowModel implements IShowModel {
    id?: string | undefined;
    dateISO?: string | undefined;
    showType?: string | undefined;
    venue?: VenueModel | undefined;
    capacity: number;
    ticketSell: number;
    budgetedPerformanceIncome: number;
    budgetedMerchIncome: number;
    budgetedOtherIncome: number;

    constructor(data?: IShowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateISO = _data["dateISO"];
            this.showType = _data["showType"];
            this.venue = _data["venue"] ? VenueModel.fromJS(_data["venue"]) : <any>undefined;
            this.capacity = _data["capacity"];
            this.ticketSell = _data["ticketSell"];
            this.budgetedPerformanceIncome = _data["budgetedPerformanceIncome"];
            this.budgetedMerchIncome = _data["budgetedMerchIncome"];
            this.budgetedOtherIncome = _data["budgetedOtherIncome"];
        }
    }

    static fromJS(data: any): ShowModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateISO"] = this.dateISO;
        data["showType"] = this.showType;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        data["capacity"] = this.capacity;
        data["ticketSell"] = this.ticketSell;
        data["budgetedPerformanceIncome"] = this.budgetedPerformanceIncome;
        data["budgetedMerchIncome"] = this.budgetedMerchIncome;
        data["budgetedOtherIncome"] = this.budgetedOtherIncome;
        return data; 
    }
}

export interface IShowModel {
    id?: string | undefined;
    dateISO?: string | undefined;
    showType?: string | undefined;
    venue?: VenueModel | undefined;
    capacity: number;
    ticketSell: number;
    budgetedPerformanceIncome: number;
    budgetedMerchIncome: number;
    budgetedOtherIncome: number;
}

export class ShowCreateModel implements IShowCreateModel {
    tourId: string;
    dateISO?: string | undefined;

    constructor(data?: IShowCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourId = _data["tourId"];
            this.dateISO = _data["dateISO"];
        }
    }

    static fromJS(data: any): ShowCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShowCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourId"] = this.tourId;
        data["dateISO"] = this.dateISO;
        return data; 
    }
}

export interface IShowCreateModel {
    tourId: string;
    dateISO?: string | undefined;
}

export class ShowDateUpdateModel implements IShowDateUpdateModel {
    dateISO?: string | undefined;

    constructor(data?: IShowDateUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateISO = _data["dateISO"];
        }
    }

    static fromJS(data: any): ShowDateUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShowDateUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateISO"] = this.dateISO;
        return data; 
    }
}

export interface IShowDateUpdateModel {
    dateISO?: string | undefined;
}

export class NonShowDateModel implements INonShowDateModel {
    id?: string | undefined;
    dateISO?: string | undefined;
    notes?: string | undefined;

    constructor(data?: INonShowDateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateISO = _data["dateISO"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): NonShowDateModel {
        data = typeof data === 'object' ? data : {};
        let result = new NonShowDateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateISO"] = this.dateISO;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface INonShowDateModel {
    id?: string | undefined;
    dateISO?: string | undefined;
    notes?: string | undefined;
}

export class TourDatesModel implements ITourDatesModel {
    shows?: ShowModel[] | undefined;
    nonShows?: NonShowDateModel[] | undefined;

    constructor(data?: ITourDatesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shows"])) {
                this.shows = [] as any;
                for (let item of _data["shows"])
                    this.shows.push(ShowModel.fromJS(item));
            }
            if (Array.isArray(_data["nonShows"])) {
                this.nonShows = [] as any;
                for (let item of _data["nonShows"])
                    this.nonShows.push(NonShowDateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TourDatesModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourDatesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shows)) {
            data["shows"] = [];
            for (let item of this.shows)
                data["shows"].push(item.toJSON());
        }
        if (Array.isArray(this.nonShows)) {
            data["nonShows"] = [];
            for (let item of this.nonShows)
                data["nonShows"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITourDatesModel {
    shows?: ShowModel[] | undefined;
    nonShows?: NonShowDateModel[] | undefined;
}

export class PublicShareCreateResponseModel implements IPublicShareCreateResponseModel {
    token: string;
    hours: number;

    constructor(data?: IPublicShareCreateResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): PublicShareCreateResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicShareCreateResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["hours"] = this.hours;
        return data; 
    }
}

export interface IPublicShareCreateResponseModel {
    token: string;
    hours: number;
}

export class PublicShareCreateModel implements IPublicShareCreateModel {
    artistId: string;
    tourId?: string | undefined;
    access: SharingAccessEnum;

    constructor(data?: IPublicShareCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artistId = _data["artistId"];
            this.tourId = _data["tourId"];
            this.access = _data["access"];
        }
    }

    static fromJS(data: any): PublicShareCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicShareCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artistId"] = this.artistId;
        data["tourId"] = this.tourId;
        data["access"] = this.access;
        return data; 
    }
}

export interface IPublicShareCreateModel {
    artistId: string;
    tourId?: string | undefined;
    access: SharingAccessEnum;
}

export enum SharingAccessEnum {
    ArtistReportDashboard = 0,
    ArtistReportSearchShows = 1,
    TourItineraryReport = 10,
    TourBudgetReport = 11,
    TourFinancialsReport = 12,
    TourTransactionsReport = 13,
    TourCommissionsReport = 14,
}

export class ShareInfoModel implements IShareInfoModel {
    artist?: ArtistModel | undefined;
    tour?: TourModel | undefined;
    expiresHours?: number | undefined;

    constructor(data?: IShareInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artist = _data["artist"] ? ArtistModel.fromJS(_data["artist"]) : <any>undefined;
            this.tour = _data["tour"] ? TourModel.fromJS(_data["tour"]) : <any>undefined;
            this.expiresHours = _data["expiresHours"];
        }
    }

    static fromJS(data: any): ShareInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artist"] = this.artist ? this.artist.toJSON() : <any>undefined;
        data["tour"] = this.tour ? this.tour.toJSON() : <any>undefined;
        data["expiresHours"] = this.expiresHours;
        return data; 
    }
}

export interface IShareInfoModel {
    artist?: ArtistModel | undefined;
    tour?: TourModel | undefined;
    expiresHours?: number | undefined;
}

export class TourModel implements ITourModel {
    id: string;
    name?: string | undefined;
    currencyCode?: string | undefined;
    notes?: string | undefined;
    artistExchangeRate: number;
    showCount: number;
    countries?: string[] | undefined;
    firstDateISO?: string | undefined;
    lastDateISO?: string | undefined;
    archived: boolean;

    constructor(data?: ITourModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.currencyCode = _data["currencyCode"];
            this.notes = _data["notes"];
            this.artistExchangeRate = _data["artistExchangeRate"];
            this.showCount = _data["showCount"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries.push(item);
            }
            this.firstDateISO = _data["firstDateISO"];
            this.lastDateISO = _data["lastDateISO"];
            this.archived = _data["archived"];
        }
    }

    static fromJS(data: any): TourModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["currencyCode"] = this.currencyCode;
        data["notes"] = this.notes;
        data["artistExchangeRate"] = this.artistExchangeRate;
        data["showCount"] = this.showCount;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        data["firstDateISO"] = this.firstDateISO;
        data["lastDateISO"] = this.lastDateISO;
        data["archived"] = this.archived;
        return data; 
    }
}

export interface ITourModel {
    id: string;
    name?: string | undefined;
    currencyCode?: string | undefined;
    notes?: string | undefined;
    artistExchangeRate: number;
    showCount: number;
    countries?: string[] | undefined;
    firstDateISO?: string | undefined;
    lastDateISO?: string | undefined;
    archived: boolean;
}

export class BudgetingToolInitialModel implements IBudgetingToolInitialModel {
    budget?: BudgetingToolModel | undefined;
    data?: BudgetToolDataModel | undefined;

    constructor(data?: IBudgetingToolInitialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budget = _data["budget"] ? BudgetingToolModel.fromJS(_data["budget"]) : <any>undefined;
            this.data = _data["data"] ? BudgetToolDataModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BudgetingToolInitialModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetingToolInitialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budget"] = this.budget ? this.budget.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBudgetingToolInitialModel {
    budget?: BudgetingToolModel | undefined;
    data?: BudgetToolDataModel | undefined;
}

export class BudgetingToolModel implements IBudgetingToolModel {
    id: string;
    name?: string | undefined;
    isManagerLocked: boolean;
    currencyCode?: string | undefined;
    allowNegativeCommissions: boolean;
    dates?: BudgetDateModel[] | undefined;
    exchangeRates?: ExchangeRateModel[] | undefined;
    categories?: CategoryBudgetModel[] | undefined;
    commissions?: CommissionsCostModel[] | undefined;
    promoterCosts?: PromoterCostBudgetModel[] | undefined;
    personnel?: PersonnelBudgetModel[] | undefined;
    travel?: BudgetToolTravelModel | undefined;
    merchCosts: number;
    tourCosts: number;
    totalCosts: number;
    otherIncome: number;
    tourIncome: number;
    performanceIncome: number;
    merchIncome: number;
    grossIncome: number;
    tourProfit: number;
    merchProfit: number;
    netProfit: number;

    constructor(data?: IBudgetingToolModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isManagerLocked = _data["isManagerLocked"];
            this.currencyCode = _data["currencyCode"];
            this.allowNegativeCommissions = _data["allowNegativeCommissions"];
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates.push(BudgetDateModel.fromJS(item));
            }
            if (Array.isArray(_data["exchangeRates"])) {
                this.exchangeRates = [] as any;
                for (let item of _data["exchangeRates"])
                    this.exchangeRates.push(ExchangeRateModel.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories.push(CategoryBudgetModel.fromJS(item));
            }
            if (Array.isArray(_data["commissions"])) {
                this.commissions = [] as any;
                for (let item of _data["commissions"])
                    this.commissions.push(CommissionsCostModel.fromJS(item));
            }
            if (Array.isArray(_data["promoterCosts"])) {
                this.promoterCosts = [] as any;
                for (let item of _data["promoterCosts"])
                    this.promoterCosts.push(PromoterCostBudgetModel.fromJS(item));
            }
            if (Array.isArray(_data["personnel"])) {
                this.personnel = [] as any;
                for (let item of _data["personnel"])
                    this.personnel.push(PersonnelBudgetModel.fromJS(item));
            }
            this.travel = _data["travel"] ? BudgetToolTravelModel.fromJS(_data["travel"]) : <any>undefined;
            this.merchCosts = _data["merchCosts"];
            this.tourCosts = _data["tourCosts"];
            this.totalCosts = _data["totalCosts"];
            this.otherIncome = _data["otherIncome"];
            this.tourIncome = _data["tourIncome"];
            this.performanceIncome = _data["performanceIncome"];
            this.merchIncome = _data["merchIncome"];
            this.grossIncome = _data["grossIncome"];
            this.tourProfit = _data["tourProfit"];
            this.merchProfit = _data["merchProfit"];
            this.netProfit = _data["netProfit"];
        }
    }

    static fromJS(data: any): BudgetingToolModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetingToolModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isManagerLocked"] = this.isManagerLocked;
        data["currencyCode"] = this.currencyCode;
        data["allowNegativeCommissions"] = this.allowNegativeCommissions;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item.toJSON());
        }
        if (Array.isArray(this.exchangeRates)) {
            data["exchangeRates"] = [];
            for (let item of this.exchangeRates)
                data["exchangeRates"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.commissions)) {
            data["commissions"] = [];
            for (let item of this.commissions)
                data["commissions"].push(item.toJSON());
        }
        if (Array.isArray(this.promoterCosts)) {
            data["promoterCosts"] = [];
            for (let item of this.promoterCosts)
                data["promoterCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.personnel)) {
            data["personnel"] = [];
            for (let item of this.personnel)
                data["personnel"].push(item.toJSON());
        }
        data["travel"] = this.travel ? this.travel.toJSON() : <any>undefined;
        data["merchCosts"] = this.merchCosts;
        data["tourCosts"] = this.tourCosts;
        data["totalCosts"] = this.totalCosts;
        data["otherIncome"] = this.otherIncome;
        data["tourIncome"] = this.tourIncome;
        data["performanceIncome"] = this.performanceIncome;
        data["merchIncome"] = this.merchIncome;
        data["grossIncome"] = this.grossIncome;
        data["tourProfit"] = this.tourProfit;
        data["merchProfit"] = this.merchProfit;
        data["netProfit"] = this.netProfit;
        return data; 
    }
}

export interface IBudgetingToolModel {
    id: string;
    name?: string | undefined;
    isManagerLocked: boolean;
    currencyCode?: string | undefined;
    allowNegativeCommissions: boolean;
    dates?: BudgetDateModel[] | undefined;
    exchangeRates?: ExchangeRateModel[] | undefined;
    categories?: CategoryBudgetModel[] | undefined;
    commissions?: CommissionsCostModel[] | undefined;
    promoterCosts?: PromoterCostBudgetModel[] | undefined;
    personnel?: PersonnelBudgetModel[] | undefined;
    travel?: BudgetToolTravelModel | undefined;
    merchCosts: number;
    tourCosts: number;
    totalCosts: number;
    otherIncome: number;
    tourIncome: number;
    performanceIncome: number;
    merchIncome: number;
    grossIncome: number;
    tourProfit: number;
    merchProfit: number;
    netProfit: number;
}

export class BudgetDateModel implements IBudgetDateModel {
    id: string;
    dateISO?: string | undefined;
    deactivated: boolean;
    notes?: string | undefined;
    flagIds?: string[] | undefined;
    flagNotes?: string[] | undefined;
    shows?: BudgetShowModel[] | undefined;
    stops?: BudgetItineraryStopModel[] | undefined;
    sequence: number;

    constructor(data?: IBudgetDateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateISO = _data["dateISO"];
            this.deactivated = _data["deactivated"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["flagIds"])) {
                this.flagIds = [] as any;
                for (let item of _data["flagIds"])
                    this.flagIds.push(item);
            }
            if (Array.isArray(_data["flagNotes"])) {
                this.flagNotes = [] as any;
                for (let item of _data["flagNotes"])
                    this.flagNotes.push(item);
            }
            if (Array.isArray(_data["shows"])) {
                this.shows = [] as any;
                for (let item of _data["shows"])
                    this.shows.push(BudgetShowModel.fromJS(item));
            }
            if (Array.isArray(_data["stops"])) {
                this.stops = [] as any;
                for (let item of _data["stops"])
                    this.stops.push(BudgetItineraryStopModel.fromJS(item));
            }
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): BudgetDateModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetDateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateISO"] = this.dateISO;
        data["deactivated"] = this.deactivated;
        data["notes"] = this.notes;
        if (Array.isArray(this.flagIds)) {
            data["flagIds"] = [];
            for (let item of this.flagIds)
                data["flagIds"].push(item);
        }
        if (Array.isArray(this.flagNotes)) {
            data["flagNotes"] = [];
            for (let item of this.flagNotes)
                data["flagNotes"].push(item);
        }
        if (Array.isArray(this.shows)) {
            data["shows"] = [];
            for (let item of this.shows)
                data["shows"].push(item.toJSON());
        }
        if (Array.isArray(this.stops)) {
            data["stops"] = [];
            for (let item of this.stops)
                data["stops"].push(item.toJSON());
        }
        data["sequence"] = this.sequence;
        return data; 
    }
}

export interface IBudgetDateModel {
    id: string;
    dateISO?: string | undefined;
    deactivated: boolean;
    notes?: string | undefined;
    flagIds?: string[] | undefined;
    flagNotes?: string[] | undefined;
    shows?: BudgetShowModel[] | undefined;
    stops?: BudgetItineraryStopModel[] | undefined;
    sequence: number;
}

export class BudgetShowModel implements IBudgetShowModel {
    id: string;
    showType?: string | undefined;
    venue?: VenueModel | undefined;
    currencyCode?: string | undefined;
    ticketPrice: number;
    ticketSell: number;
    attendance: number;
    capacity: number;
    ticketLevels?: BudgetTicketingModel[] | undefined;
    ticketSellPercentage: number;
    ticketPriceNotes?: string | undefined;
    ticketSellCalculation: TicketSellCalculationType;
    guaranteeIncome: number;
    guaranteeIncomeNotes?: string | undefined;
    flatFeeIncome: number;
    flatFeeIncomeNotes?: string | undefined;
    promoterCost: number;
    promoterCostNotes?: string | undefined;
    promoterPercentage: number;
    artistBonusPercentage: number;
    artistBonusTicketThreshold: number;
    promoterDealArtistBonus: number;
    dealType: BudgetShowDealTypeEnum;
    merchIncomeCalculation?: string | undefined;
    merchUnitAmount: number;
    merchUnitQty: number;
    merchIncomeNotes?: string | undefined;
    merchIncomeCurrencyCode?: string | undefined;
    merchIncomeFromPresetId?: string | undefined;
    performanceIncome: number;
    performanceIncomeTourCurrency: number;
    merchIncomeTourCurrency: number;
    merchCostTourCurrency: number;
    otherIncomeTourCurrency: number;
    showIncome: number;
    showIncomeTourCurrency: number;
    showCostsCategoryCosts: number;
    showCostsCategoryCostsTourCurrency: number;
    tourCosts: number;
    tourCostsTourCurrency: number;
    showProfit: number;
    showProfitTourCurrency: number;
    tourProfitTourCurrency: number;

    constructor(data?: IBudgetShowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.showType = _data["showType"];
            this.venue = _data["venue"] ? VenueModel.fromJS(_data["venue"]) : <any>undefined;
            this.currencyCode = _data["currencyCode"];
            this.ticketPrice = _data["ticketPrice"];
            this.ticketSell = _data["ticketSell"];
            this.attendance = _data["attendance"];
            this.capacity = _data["capacity"];
            if (Array.isArray(_data["ticketLevels"])) {
                this.ticketLevels = [] as any;
                for (let item of _data["ticketLevels"])
                    this.ticketLevels.push(BudgetTicketingModel.fromJS(item));
            }
            this.ticketSellPercentage = _data["ticketSellPercentage"];
            this.ticketPriceNotes = _data["ticketPriceNotes"];
            this.ticketSellCalculation = _data["ticketSellCalculation"];
            this.guaranteeIncome = _data["guaranteeIncome"];
            this.guaranteeIncomeNotes = _data["guaranteeIncomeNotes"];
            this.flatFeeIncome = _data["flatFeeIncome"];
            this.flatFeeIncomeNotes = _data["flatFeeIncomeNotes"];
            this.promoterCost = _data["promoterCost"];
            this.promoterCostNotes = _data["promoterCostNotes"];
            this.promoterPercentage = _data["promoterPercentage"];
            this.artistBonusPercentage = _data["artistBonusPercentage"];
            this.artistBonusTicketThreshold = _data["artistBonusTicketThreshold"];
            this.promoterDealArtistBonus = _data["promoterDealArtistBonus"];
            this.dealType = _data["dealType"];
            this.merchIncomeCalculation = _data["merchIncomeCalculation"];
            this.merchUnitAmount = _data["merchUnitAmount"];
            this.merchUnitQty = _data["merchUnitQty"];
            this.merchIncomeNotes = _data["merchIncomeNotes"];
            this.merchIncomeCurrencyCode = _data["merchIncomeCurrencyCode"];
            this.merchIncomeFromPresetId = _data["merchIncomeFromPresetId"];
            this.performanceIncome = _data["performanceIncome"];
            this.performanceIncomeTourCurrency = _data["performanceIncomeTourCurrency"];
            this.merchIncomeTourCurrency = _data["merchIncomeTourCurrency"];
            this.merchCostTourCurrency = _data["merchCostTourCurrency"];
            this.otherIncomeTourCurrency = _data["otherIncomeTourCurrency"];
            this.showIncome = _data["showIncome"];
            this.showIncomeTourCurrency = _data["showIncomeTourCurrency"];
            this.showCostsCategoryCosts = _data["showCostsCategoryCosts"];
            this.showCostsCategoryCostsTourCurrency = _data["showCostsCategoryCostsTourCurrency"];
            this.tourCosts = _data["tourCosts"];
            this.tourCostsTourCurrency = _data["tourCostsTourCurrency"];
            this.showProfit = _data["showProfit"];
            this.showProfitTourCurrency = _data["showProfitTourCurrency"];
            this.tourProfitTourCurrency = _data["tourProfitTourCurrency"];
        }
    }

    static fromJS(data: any): BudgetShowModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetShowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showType"] = this.showType;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        data["currencyCode"] = this.currencyCode;
        data["ticketPrice"] = this.ticketPrice;
        data["ticketSell"] = this.ticketSell;
        data["attendance"] = this.attendance;
        data["capacity"] = this.capacity;
        if (Array.isArray(this.ticketLevels)) {
            data["ticketLevels"] = [];
            for (let item of this.ticketLevels)
                data["ticketLevels"].push(item.toJSON());
        }
        data["ticketSellPercentage"] = this.ticketSellPercentage;
        data["ticketPriceNotes"] = this.ticketPriceNotes;
        data["ticketSellCalculation"] = this.ticketSellCalculation;
        data["guaranteeIncome"] = this.guaranteeIncome;
        data["guaranteeIncomeNotes"] = this.guaranteeIncomeNotes;
        data["flatFeeIncome"] = this.flatFeeIncome;
        data["flatFeeIncomeNotes"] = this.flatFeeIncomeNotes;
        data["promoterCost"] = this.promoterCost;
        data["promoterCostNotes"] = this.promoterCostNotes;
        data["promoterPercentage"] = this.promoterPercentage;
        data["artistBonusPercentage"] = this.artistBonusPercentage;
        data["artistBonusTicketThreshold"] = this.artistBonusTicketThreshold;
        data["promoterDealArtistBonus"] = this.promoterDealArtistBonus;
        data["dealType"] = this.dealType;
        data["merchIncomeCalculation"] = this.merchIncomeCalculation;
        data["merchUnitAmount"] = this.merchUnitAmount;
        data["merchUnitQty"] = this.merchUnitQty;
        data["merchIncomeNotes"] = this.merchIncomeNotes;
        data["merchIncomeCurrencyCode"] = this.merchIncomeCurrencyCode;
        data["merchIncomeFromPresetId"] = this.merchIncomeFromPresetId;
        data["performanceIncome"] = this.performanceIncome;
        data["performanceIncomeTourCurrency"] = this.performanceIncomeTourCurrency;
        data["merchIncomeTourCurrency"] = this.merchIncomeTourCurrency;
        data["merchCostTourCurrency"] = this.merchCostTourCurrency;
        data["otherIncomeTourCurrency"] = this.otherIncomeTourCurrency;
        data["showIncome"] = this.showIncome;
        data["showIncomeTourCurrency"] = this.showIncomeTourCurrency;
        data["showCostsCategoryCosts"] = this.showCostsCategoryCosts;
        data["showCostsCategoryCostsTourCurrency"] = this.showCostsCategoryCostsTourCurrency;
        data["tourCosts"] = this.tourCosts;
        data["tourCostsTourCurrency"] = this.tourCostsTourCurrency;
        data["showProfit"] = this.showProfit;
        data["showProfitTourCurrency"] = this.showProfitTourCurrency;
        data["tourProfitTourCurrency"] = this.tourProfitTourCurrency;
        return data; 
    }
}

export interface IBudgetShowModel {
    id: string;
    showType?: string | undefined;
    venue?: VenueModel | undefined;
    currencyCode?: string | undefined;
    ticketPrice: number;
    ticketSell: number;
    attendance: number;
    capacity: number;
    ticketLevels?: BudgetTicketingModel[] | undefined;
    ticketSellPercentage: number;
    ticketPriceNotes?: string | undefined;
    ticketSellCalculation: TicketSellCalculationType;
    guaranteeIncome: number;
    guaranteeIncomeNotes?: string | undefined;
    flatFeeIncome: number;
    flatFeeIncomeNotes?: string | undefined;
    promoterCost: number;
    promoterCostNotes?: string | undefined;
    promoterPercentage: number;
    artistBonusPercentage: number;
    artistBonusTicketThreshold: number;
    promoterDealArtistBonus: number;
    dealType: BudgetShowDealTypeEnum;
    merchIncomeCalculation?: string | undefined;
    merchUnitAmount: number;
    merchUnitQty: number;
    merchIncomeNotes?: string | undefined;
    merchIncomeCurrencyCode?: string | undefined;
    merchIncomeFromPresetId?: string | undefined;
    performanceIncome: number;
    performanceIncomeTourCurrency: number;
    merchIncomeTourCurrency: number;
    merchCostTourCurrency: number;
    otherIncomeTourCurrency: number;
    showIncome: number;
    showIncomeTourCurrency: number;
    showCostsCategoryCosts: number;
    showCostsCategoryCostsTourCurrency: number;
    tourCosts: number;
    tourCostsTourCurrency: number;
    showProfit: number;
    showProfitTourCurrency: number;
    tourProfitTourCurrency: number;
}

export class BudgetTicketingModel implements IBudgetTicketingModel {
    ticketPrice: number;
    ticketSell: number;
    capacity: number;

    constructor(data?: IBudgetTicketingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketPrice = _data["ticketPrice"];
            this.ticketSell = _data["ticketSell"];
            this.capacity = _data["capacity"];
        }
    }

    static fromJS(data: any): BudgetTicketingModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetTicketingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketPrice"] = this.ticketPrice;
        data["ticketSell"] = this.ticketSell;
        data["capacity"] = this.capacity;
        return data; 
    }
}

export interface IBudgetTicketingModel {
    ticketPrice: number;
    ticketSell: number;
    capacity: number;
}

export enum TicketSellCalculationType {
    Sell = 0,
    Percentage = 1,
}

export enum BudgetShowDealTypeEnum {
    Ticketed = 0,
    FlattFee = 1,
    VersusDeal = 2,
    PlusDeal = 3,
}

export class BudgetItineraryStopModel implements IBudgetItineraryStopModel {
    id: string;
    venue?: VenueModel | undefined;

    constructor(data?: IBudgetItineraryStopModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.venue = _data["venue"] ? VenueModel.fromJS(_data["venue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BudgetItineraryStopModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetItineraryStopModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBudgetItineraryStopModel {
    id: string;
    venue?: VenueModel | undefined;
}

export class ExchangeRateModel implements IExchangeRateModel {
    currencyCode?: string | undefined;
    rate: number;

    constructor(data?: IExchangeRateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): ExchangeRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeRateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["rate"] = this.rate;
        return data; 
    }
}

export interface IExchangeRateModel {
    currencyCode?: string | undefined;
    rate: number;
}

export class CategoryBudgetModel implements ICategoryBudgetModel {
    category?: string | undefined;
    isCost: boolean;
    contingency?: ContingencyBudgetModel | undefined;
    subcategories?: SubcategoryBudgetModel[] | undefined;
    total: number;

    constructor(data?: ICategoryBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.isCost = _data["isCost"];
            this.contingency = _data["contingency"] ? ContingencyBudgetModel.fromJS(_data["contingency"]) : <any>undefined;
            if (Array.isArray(_data["subcategories"])) {
                this.subcategories = [] as any;
                for (let item of _data["subcategories"])
                    this.subcategories.push(SubcategoryBudgetModel.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CategoryBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["isCost"] = this.isCost;
        data["contingency"] = this.contingency ? this.contingency.toJSON() : <any>undefined;
        if (Array.isArray(this.subcategories)) {
            data["subcategories"] = [];
            for (let item of this.subcategories)
                data["subcategories"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data; 
    }
}

export interface ICategoryBudgetModel {
    category?: string | undefined;
    isCost: boolean;
    contingency?: ContingencyBudgetModel | undefined;
    subcategories?: SubcategoryBudgetModel[] | undefined;
    total: number;
}

export class ContingencyBudgetModel implements IContingencyBudgetModel {
    percentage: number;
    fromPreset: boolean;
    deactivated: boolean;
    amount: number;

    constructor(data?: IContingencyBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.fromPreset = _data["fromPreset"];
            this.deactivated = _data["deactivated"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ContingencyBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContingencyBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["fromPreset"] = this.fromPreset;
        data["deactivated"] = this.deactivated;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IContingencyBudgetModel {
    percentage: number;
    fromPreset: boolean;
    deactivated: boolean;
    amount: number;
}

export class SubcategoryBudgetModel implements ISubcategoryBudgetModel {
    id: string;
    deactivated: boolean;
    subcategory?: string | undefined;
    notes?: string | undefined;
    flagIds?: string[] | undefined;
    flagNotes?: string[] | undefined;
    calculation?: string | undefined;
    currencyCode?: string | undefined;
    qty: number;
    unitAmount: number;
    totalSubCategoryCurrency: number;
    totalTourCurrency: number;
    showAllocations?: ShowAllocationsModel | undefined;
    invalidReason: SubcategoryInvalidReason;
    sequence: number;
    fromPresetId?: string | undefined;
    originalPresetId?: string | undefined;

    constructor(data?: ISubcategoryBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deactivated = _data["deactivated"];
            this.subcategory = _data["subcategory"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["flagIds"])) {
                this.flagIds = [] as any;
                for (let item of _data["flagIds"])
                    this.flagIds.push(item);
            }
            if (Array.isArray(_data["flagNotes"])) {
                this.flagNotes = [] as any;
                for (let item of _data["flagNotes"])
                    this.flagNotes.push(item);
            }
            this.calculation = _data["calculation"];
            this.currencyCode = _data["currencyCode"];
            this.qty = _data["qty"];
            this.unitAmount = _data["unitAmount"];
            this.totalSubCategoryCurrency = _data["totalSubCategoryCurrency"];
            this.totalTourCurrency = _data["totalTourCurrency"];
            this.showAllocations = _data["showAllocations"] ? ShowAllocationsModel.fromJS(_data["showAllocations"]) : <any>undefined;
            this.invalidReason = _data["invalidReason"];
            this.sequence = _data["sequence"];
            this.fromPresetId = _data["fromPresetId"];
            this.originalPresetId = _data["originalPresetId"];
        }
    }

    static fromJS(data: any): SubcategoryBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubcategoryBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deactivated"] = this.deactivated;
        data["subcategory"] = this.subcategory;
        data["notes"] = this.notes;
        if (Array.isArray(this.flagIds)) {
            data["flagIds"] = [];
            for (let item of this.flagIds)
                data["flagIds"].push(item);
        }
        if (Array.isArray(this.flagNotes)) {
            data["flagNotes"] = [];
            for (let item of this.flagNotes)
                data["flagNotes"].push(item);
        }
        data["calculation"] = this.calculation;
        data["currencyCode"] = this.currencyCode;
        data["qty"] = this.qty;
        data["unitAmount"] = this.unitAmount;
        data["totalSubCategoryCurrency"] = this.totalSubCategoryCurrency;
        data["totalTourCurrency"] = this.totalTourCurrency;
        data["showAllocations"] = this.showAllocations ? this.showAllocations.toJSON() : <any>undefined;
        data["invalidReason"] = this.invalidReason;
        data["sequence"] = this.sequence;
        data["fromPresetId"] = this.fromPresetId;
        data["originalPresetId"] = this.originalPresetId;
        return data; 
    }
}

export interface ISubcategoryBudgetModel {
    id: string;
    deactivated: boolean;
    subcategory?: string | undefined;
    notes?: string | undefined;
    flagIds?: string[] | undefined;
    flagNotes?: string[] | undefined;
    calculation?: string | undefined;
    currencyCode?: string | undefined;
    qty: number;
    unitAmount: number;
    totalSubCategoryCurrency: number;
    totalTourCurrency: number;
    showAllocations?: ShowAllocationsModel | undefined;
    invalidReason: SubcategoryInvalidReason;
    sequence: number;
    fromPresetId?: string | undefined;
    originalPresetId?: string | undefined;
}

export class ShowAllocationsModel implements IShowAllocationsModel {
    splitType: BudgetShowAllocationSplitTypeEnum;
    allocationType: BudgetShowAllocationTypeEnum;
    showIds?: string[] | undefined;

    constructor(data?: IShowAllocationsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.splitType = _data["splitType"];
            this.allocationType = _data["allocationType"];
            if (Array.isArray(_data["showIds"])) {
                this.showIds = [] as any;
                for (let item of _data["showIds"])
                    this.showIds.push(item);
            }
        }
    }

    static fromJS(data: any): ShowAllocationsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShowAllocationsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["splitType"] = this.splitType;
        data["allocationType"] = this.allocationType;
        if (Array.isArray(this.showIds)) {
            data["showIds"] = [];
            for (let item of this.showIds)
                data["showIds"].push(item);
        }
        return data; 
    }
}

export interface IShowAllocationsModel {
    splitType: BudgetShowAllocationSplitTypeEnum;
    allocationType: BudgetShowAllocationTypeEnum;
    showIds?: string[] | undefined;
}

export enum BudgetShowAllocationSplitTypeEnum {
    PercentageIncome = 0,
    EqualSplit = 1,
    PercentageTickets = 2,
    PercentageMerchIncome = 3,
}

export enum BudgetShowAllocationTypeEnum {
    All = 0,
    Some = 1,
}

export enum SubcategoryInvalidReason {
    None = 0,
    AllocatedShowMissing = 1,
}

export class CommissionsCostModel implements ICommissionsCostModel {
    id: string;
    deactivated: boolean;
    subcategory?: string | undefined;
    defaultIncomeInclusions?: ShowIncomeDefaultPartsModel | undefined;
    customShowIncome?: CommissionShowIncomeModel[] | undefined;
    ratePercentage: number;
    notes?: string | undefined;
    flagIds?: string[] | undefined;
    flagNotes?: string[] | undefined;
    deductibleCosts?: CommissionsDeductibleCostModel[] | undefined;
    commissionableProfit: number;
    totalIncome: number;
    totalDeductibleCosts: number;
    totalCommission: number;
    sequence: number;
    fromPresetId?: string | undefined;
    originalPresetId?: string | undefined;

    constructor(data?: ICommissionsCostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deactivated = _data["deactivated"];
            this.subcategory = _data["subcategory"];
            this.defaultIncomeInclusions = _data["defaultIncomeInclusions"] ? ShowIncomeDefaultPartsModel.fromJS(_data["defaultIncomeInclusions"]) : <any>undefined;
            if (Array.isArray(_data["customShowIncome"])) {
                this.customShowIncome = [] as any;
                for (let item of _data["customShowIncome"])
                    this.customShowIncome.push(CommissionShowIncomeModel.fromJS(item));
            }
            this.ratePercentage = _data["ratePercentage"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["flagIds"])) {
                this.flagIds = [] as any;
                for (let item of _data["flagIds"])
                    this.flagIds.push(item);
            }
            if (Array.isArray(_data["flagNotes"])) {
                this.flagNotes = [] as any;
                for (let item of _data["flagNotes"])
                    this.flagNotes.push(item);
            }
            if (Array.isArray(_data["deductibleCosts"])) {
                this.deductibleCosts = [] as any;
                for (let item of _data["deductibleCosts"])
                    this.deductibleCosts.push(CommissionsDeductibleCostModel.fromJS(item));
            }
            this.commissionableProfit = _data["commissionableProfit"];
            this.totalIncome = _data["totalIncome"];
            this.totalDeductibleCosts = _data["totalDeductibleCosts"];
            this.totalCommission = _data["totalCommission"];
            this.sequence = _data["sequence"];
            this.fromPresetId = _data["fromPresetId"];
            this.originalPresetId = _data["originalPresetId"];
        }
    }

    static fromJS(data: any): CommissionsCostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionsCostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deactivated"] = this.deactivated;
        data["subcategory"] = this.subcategory;
        data["defaultIncomeInclusions"] = this.defaultIncomeInclusions ? this.defaultIncomeInclusions.toJSON() : <any>undefined;
        if (Array.isArray(this.customShowIncome)) {
            data["customShowIncome"] = [];
            for (let item of this.customShowIncome)
                data["customShowIncome"].push(item.toJSON());
        }
        data["ratePercentage"] = this.ratePercentage;
        data["notes"] = this.notes;
        if (Array.isArray(this.flagIds)) {
            data["flagIds"] = [];
            for (let item of this.flagIds)
                data["flagIds"].push(item);
        }
        if (Array.isArray(this.flagNotes)) {
            data["flagNotes"] = [];
            for (let item of this.flagNotes)
                data["flagNotes"].push(item);
        }
        if (Array.isArray(this.deductibleCosts)) {
            data["deductibleCosts"] = [];
            for (let item of this.deductibleCosts)
                data["deductibleCosts"].push(item.toJSON());
        }
        data["commissionableProfit"] = this.commissionableProfit;
        data["totalIncome"] = this.totalIncome;
        data["totalDeductibleCosts"] = this.totalDeductibleCosts;
        data["totalCommission"] = this.totalCommission;
        data["sequence"] = this.sequence;
        data["fromPresetId"] = this.fromPresetId;
        data["originalPresetId"] = this.originalPresetId;
        return data; 
    }
}

export interface ICommissionsCostModel {
    id: string;
    deactivated: boolean;
    subcategory?: string | undefined;
    defaultIncomeInclusions?: ShowIncomeDefaultPartsModel | undefined;
    customShowIncome?: CommissionShowIncomeModel[] | undefined;
    ratePercentage: number;
    notes?: string | undefined;
    flagIds?: string[] | undefined;
    flagNotes?: string[] | undefined;
    deductibleCosts?: CommissionsDeductibleCostModel[] | undefined;
    commissionableProfit: number;
    totalIncome: number;
    totalDeductibleCosts: number;
    totalCommission: number;
    sequence: number;
    fromPresetId?: string | undefined;
    originalPresetId?: string | undefined;
}

export class ShowIncomeDefaultPartsModel implements IShowIncomeDefaultPartsModel {
    performance: boolean;
    other: CommissionSubCategoriesSelectEnum;
    otherSubcategoryNames?: string[] | undefined;

    constructor(data?: IShowIncomeDefaultPartsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.performance = _data["performance"];
            this.other = _data["other"];
            if (Array.isArray(_data["otherSubcategoryNames"])) {
                this.otherSubcategoryNames = [] as any;
                for (let item of _data["otherSubcategoryNames"])
                    this.otherSubcategoryNames.push(item);
            }
        }
    }

    static fromJS(data: any): ShowIncomeDefaultPartsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShowIncomeDefaultPartsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["performance"] = this.performance;
        data["other"] = this.other;
        if (Array.isArray(this.otherSubcategoryNames)) {
            data["otherSubcategoryNames"] = [];
            for (let item of this.otherSubcategoryNames)
                data["otherSubcategoryNames"].push(item);
        }
        return data; 
    }
}

export interface IShowIncomeDefaultPartsModel {
    performance: boolean;
    other: CommissionSubCategoriesSelectEnum;
    otherSubcategoryNames?: string[] | undefined;
}

export enum CommissionSubCategoriesSelectEnum {
    All = 0,
    None = 1,
    Some = 2,
}

export class CommissionShowIncomeModel implements ICommissionShowIncomeModel {
    showId: string;
    inclusions?: ShowIncomePartsModel | undefined;

    constructor(data?: ICommissionShowIncomeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showId = _data["showId"];
            this.inclusions = _data["inclusions"] ? ShowIncomePartsModel.fromJS(_data["inclusions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommissionShowIncomeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionShowIncomeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showId"] = this.showId;
        data["inclusions"] = this.inclusions ? this.inclusions.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICommissionShowIncomeModel {
    showId: string;
    inclusions?: ShowIncomePartsModel | undefined;
}

export class ShowIncomePartsModel implements IShowIncomePartsModel {
    performance: boolean;
    other: CommissionSubCategoriesSelectEnum;
    otherSubcategoryNames?: string[] | undefined;

    constructor(data?: IShowIncomePartsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.performance = _data["performance"];
            this.other = _data["other"];
            if (Array.isArray(_data["otherSubcategoryNames"])) {
                this.otherSubcategoryNames = [] as any;
                for (let item of _data["otherSubcategoryNames"])
                    this.otherSubcategoryNames.push(item);
            }
        }
    }

    static fromJS(data: any): ShowIncomePartsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShowIncomePartsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["performance"] = this.performance;
        data["other"] = this.other;
        if (Array.isArray(this.otherSubcategoryNames)) {
            data["otherSubcategoryNames"] = [];
            for (let item of this.otherSubcategoryNames)
                data["otherSubcategoryNames"].push(item);
        }
        return data; 
    }
}

export interface IShowIncomePartsModel {
    performance: boolean;
    other: CommissionSubCategoriesSelectEnum;
    otherSubcategoryNames?: string[] | undefined;
}

export class CommissionsDeductibleCostModel implements ICommissionsDeductibleCostModel {
    id: string;
    category?: string | undefined;
    subCategoriesSelection: CommissionSubCategoriesSelectEnum;
    subcategoryNames?: string[] | undefined;
    total: number;

    constructor(data?: ICommissionsDeductibleCostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.subCategoriesSelection = _data["subCategoriesSelection"];
            if (Array.isArray(_data["subcategoryNames"])) {
                this.subcategoryNames = [] as any;
                for (let item of _data["subcategoryNames"])
                    this.subcategoryNames.push(item);
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CommissionsDeductibleCostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionsDeductibleCostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["subCategoriesSelection"] = this.subCategoriesSelection;
        if (Array.isArray(this.subcategoryNames)) {
            data["subcategoryNames"] = [];
            for (let item of this.subcategoryNames)
                data["subcategoryNames"].push(item);
        }
        data["total"] = this.total;
        return data; 
    }
}

export interface ICommissionsDeductibleCostModel {
    id: string;
    category?: string | undefined;
    subCategoriesSelection: CommissionSubCategoriesSelectEnum;
    subcategoryNames?: string[] | undefined;
    total: number;
}

export class PromoterCostBudgetModel implements IPromoterCostBudgetModel {
    id: string;
    showId: string;
    notes?: string | undefined;
    calculation?: string | undefined;
    qty: number;
    unitAmount: number;
    sequence: number;
    totalShowCurrency: number;

    constructor(data?: IPromoterCostBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.showId = _data["showId"];
            this.notes = _data["notes"];
            this.calculation = _data["calculation"];
            this.qty = _data["qty"];
            this.unitAmount = _data["unitAmount"];
            this.sequence = _data["sequence"];
            this.totalShowCurrency = _data["totalShowCurrency"];
        }
    }

    static fromJS(data: any): PromoterCostBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromoterCostBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showId"] = this.showId;
        data["notes"] = this.notes;
        data["calculation"] = this.calculation;
        data["qty"] = this.qty;
        data["unitAmount"] = this.unitAmount;
        data["sequence"] = this.sequence;
        data["totalShowCurrency"] = this.totalShowCurrency;
        return data; 
    }
}

export interface IPromoterCostBudgetModel {
    id: string;
    showId: string;
    notes?: string | undefined;
    calculation?: string | undefined;
    qty: number;
    unitAmount: number;
    sequence: number;
    totalShowCurrency: number;
}

export class PersonnelBudgetModel implements IPersonnelBudgetModel {
    id: string;
    subcategoryId: string;
    personPresetIdentifier?: string | undefined;
    showDayRate?: PersonnelDayRateBudgetModel | undefined;
    nonShowDayRate?: PersonnelDayRateBudgetModel | undefined;
    mealAllowance?: PersonnelDayRateBudgetModel | undefined;
    preTourFlatFee: number;
    payrollTax?: PersonnelDayRateBudgetModel | undefined;

    constructor(data?: IPersonnelBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subcategoryId = _data["subcategoryId"];
            this.personPresetIdentifier = _data["personPresetIdentifier"];
            this.showDayRate = _data["showDayRate"] ? PersonnelDayRateBudgetModel.fromJS(_data["showDayRate"]) : <any>undefined;
            this.nonShowDayRate = _data["nonShowDayRate"] ? PersonnelDayRateBudgetModel.fromJS(_data["nonShowDayRate"]) : <any>undefined;
            this.mealAllowance = _data["mealAllowance"] ? PersonnelDayRateBudgetModel.fromJS(_data["mealAllowance"]) : <any>undefined;
            this.preTourFlatFee = _data["preTourFlatFee"];
            this.payrollTax = _data["payrollTax"] ? PersonnelDayRateBudgetModel.fromJS(_data["payrollTax"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonnelBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonnelBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subcategoryId"] = this.subcategoryId;
        data["personPresetIdentifier"] = this.personPresetIdentifier;
        data["showDayRate"] = this.showDayRate ? this.showDayRate.toJSON() : <any>undefined;
        data["nonShowDayRate"] = this.nonShowDayRate ? this.nonShowDayRate.toJSON() : <any>undefined;
        data["mealAllowance"] = this.mealAllowance ? this.mealAllowance.toJSON() : <any>undefined;
        data["preTourFlatFee"] = this.preTourFlatFee;
        data["payrollTax"] = this.payrollTax ? this.payrollTax.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPersonnelBudgetModel {
    id: string;
    subcategoryId: string;
    personPresetIdentifier?: string | undefined;
    showDayRate?: PersonnelDayRateBudgetModel | undefined;
    nonShowDayRate?: PersonnelDayRateBudgetModel | undefined;
    mealAllowance?: PersonnelDayRateBudgetModel | undefined;
    preTourFlatFee: number;
    payrollTax?: PersonnelDayRateBudgetModel | undefined;
}

export class PersonnelDayRateBudgetModel implements IPersonnelDayRateBudgetModel {
    rate: number;
    days: number;
    useCustomDays: boolean;

    constructor(data?: IPersonnelDayRateBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"];
            this.days = _data["days"];
            this.useCustomDays = _data["useCustomDays"];
        }
    }

    static fromJS(data: any): PersonnelDayRateBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonnelDayRateBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        data["days"] = this.days;
        data["useCustomDays"] = this.useCustomDays;
        return data; 
    }
}

export interface IPersonnelDayRateBudgetModel {
    rate: number;
    days: number;
    useCustomDays: boolean;
}

export class BudgetToolTravelModel implements IBudgetToolTravelModel {
    startLocation?: VenueModel | undefined;
    endLocation?: VenueModel | undefined;
    estimateData?: BudgetToolTravelEstimateDataModel | undefined;
    distances?: BudgetToolTravelDistanceModel[] | undefined;

    constructor(data?: IBudgetToolTravelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startLocation = _data["startLocation"] ? VenueModel.fromJS(_data["startLocation"]) : <any>undefined;
            this.endLocation = _data["endLocation"] ? VenueModel.fromJS(_data["endLocation"]) : <any>undefined;
            this.estimateData = _data["estimateData"] ? BudgetToolTravelEstimateDataModel.fromJS(_data["estimateData"]) : <any>undefined;
            if (Array.isArray(_data["distances"])) {
                this.distances = [] as any;
                for (let item of _data["distances"])
                    this.distances.push(BudgetToolTravelDistanceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetToolTravelModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetToolTravelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startLocation"] = this.startLocation ? this.startLocation.toJSON() : <any>undefined;
        data["endLocation"] = this.endLocation ? this.endLocation.toJSON() : <any>undefined;
        data["estimateData"] = this.estimateData ? this.estimateData.toJSON() : <any>undefined;
        if (Array.isArray(this.distances)) {
            data["distances"] = [];
            for (let item of this.distances)
                data["distances"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBudgetToolTravelModel {
    startLocation?: VenueModel | undefined;
    endLocation?: VenueModel | undefined;
    estimateData?: BudgetToolTravelEstimateDataModel | undefined;
    distances?: BudgetToolTravelDistanceModel[] | undefined;
}

export class BudgetToolTravelEstimateDataModel implements IBudgetToolTravelEstimateDataModel {
    costPerKm: number;
    miscDailyCost: number;

    constructor(data?: IBudgetToolTravelEstimateDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costPerKm = _data["costPerKm"];
            this.miscDailyCost = _data["miscDailyCost"];
        }
    }

    static fromJS(data: any): BudgetToolTravelEstimateDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetToolTravelEstimateDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costPerKm"] = this.costPerKm;
        data["miscDailyCost"] = this.miscDailyCost;
        return data; 
    }
}

export interface IBudgetToolTravelEstimateDataModel {
    costPerKm: number;
    miscDailyCost: number;
}

export class BudgetToolTravelDistanceModel implements IBudgetToolTravelDistanceModel {
    id: string;
    from?: BudgetLatLngModel | undefined;
    to?: BudgetLatLngModel | undefined;
    calculation: BudgetToolTravelCalculation;
    kms: number;
    hours: number;
    hoursText?: string | undefined;

    constructor(data?: IBudgetToolTravelDistanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? BudgetLatLngModel.fromJS(_data["from"]) : <any>undefined;
            this.to = _data["to"] ? BudgetLatLngModel.fromJS(_data["to"]) : <any>undefined;
            this.calculation = _data["calculation"];
            this.kms = _data["kms"];
            this.hours = _data["hours"];
            this.hoursText = _data["hoursText"];
        }
    }

    static fromJS(data: any): BudgetToolTravelDistanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetToolTravelDistanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["to"] = this.to ? this.to.toJSON() : <any>undefined;
        data["calculation"] = this.calculation;
        data["kms"] = this.kms;
        data["hours"] = this.hours;
        data["hoursText"] = this.hoursText;
        return data; 
    }
}

export interface IBudgetToolTravelDistanceModel {
    id: string;
    from?: BudgetLatLngModel | undefined;
    to?: BudgetLatLngModel | undefined;
    calculation: BudgetToolTravelCalculation;
    kms: number;
    hours: number;
    hoursText?: string | undefined;
}

export class BudgetLatLngModel implements IBudgetLatLngModel {
    latitude: number;
    longitude: number;

    constructor(data?: IBudgetLatLngModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): BudgetLatLngModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetLatLngModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }
}

export interface IBudgetLatLngModel {
    latitude: number;
    longitude: number;
}

export enum BudgetToolTravelCalculation {
    Straight = 0,
    Car = 1,
    Air = 2,
}

export class BudgetToolDataModel implements IBudgetToolDataModel {
    categories?: CategoryModel[] | undefined;
    showTypes?: string[] | undefined;
    addInitialPresets: boolean;
    addShowPresets: boolean;

    constructor(data?: IBudgetToolDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories.push(CategoryModel.fromJS(item));
            }
            if (Array.isArray(_data["showTypes"])) {
                this.showTypes = [] as any;
                for (let item of _data["showTypes"])
                    this.showTypes.push(item);
            }
            this.addInitialPresets = _data["addInitialPresets"];
            this.addShowPresets = _data["addShowPresets"];
        }
    }

    static fromJS(data: any): BudgetToolDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetToolDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.showTypes)) {
            data["showTypes"] = [];
            for (let item of this.showTypes)
                data["showTypes"].push(item);
        }
        data["addInitialPresets"] = this.addInitialPresets;
        data["addShowPresets"] = this.addShowPresets;
        return data; 
    }
}

export interface IBudgetToolDataModel {
    categories?: CategoryModel[] | undefined;
    showTypes?: string[] | undefined;
    addInitialPresets: boolean;
    addShowPresets: boolean;
}

export class TourMegaReportModel implements ITourMegaReportModel {
    currencyCode?: string | undefined;
    data?: TourMegaReportDataModel | undefined;
    tourIncomeTotals?: TourMegaReportAmountsModel | undefined;
    tourCostTotals?: TourMegaReportAmountsModel | undefined;
    tourProfit?: TourMegaReportAmountsModel | undefined;
    merchIncomeTotals?: TourMegaReportAmountsModel | undefined;
    merchCostTotals?: TourMegaReportAmountsModel | undefined;
    merchProfit?: TourMegaReportAmountsModel | undefined;
    netProfit?: TourMegaReportAmountsModel | undefined;

    constructor(data?: ITourMegaReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.data = _data["data"] ? TourMegaReportDataModel.fromJS(_data["data"]) : <any>undefined;
            this.tourIncomeTotals = _data["tourIncomeTotals"] ? TourMegaReportAmountsModel.fromJS(_data["tourIncomeTotals"]) : <any>undefined;
            this.tourCostTotals = _data["tourCostTotals"] ? TourMegaReportAmountsModel.fromJS(_data["tourCostTotals"]) : <any>undefined;
            this.tourProfit = _data["tourProfit"] ? TourMegaReportAmountsModel.fromJS(_data["tourProfit"]) : <any>undefined;
            this.merchIncomeTotals = _data["merchIncomeTotals"] ? TourMegaReportAmountsModel.fromJS(_data["merchIncomeTotals"]) : <any>undefined;
            this.merchCostTotals = _data["merchCostTotals"] ? TourMegaReportAmountsModel.fromJS(_data["merchCostTotals"]) : <any>undefined;
            this.merchProfit = _data["merchProfit"] ? TourMegaReportAmountsModel.fromJS(_data["merchProfit"]) : <any>undefined;
            this.netProfit = _data["netProfit"] ? TourMegaReportAmountsModel.fromJS(_data["netProfit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TourMegaReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourMegaReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["tourIncomeTotals"] = this.tourIncomeTotals ? this.tourIncomeTotals.toJSON() : <any>undefined;
        data["tourCostTotals"] = this.tourCostTotals ? this.tourCostTotals.toJSON() : <any>undefined;
        data["tourProfit"] = this.tourProfit ? this.tourProfit.toJSON() : <any>undefined;
        data["merchIncomeTotals"] = this.merchIncomeTotals ? this.merchIncomeTotals.toJSON() : <any>undefined;
        data["merchCostTotals"] = this.merchCostTotals ? this.merchCostTotals.toJSON() : <any>undefined;
        data["merchProfit"] = this.merchProfit ? this.merchProfit.toJSON() : <any>undefined;
        data["netProfit"] = this.netProfit ? this.netProfit.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITourMegaReportModel {
    currencyCode?: string | undefined;
    data?: TourMegaReportDataModel | undefined;
    tourIncomeTotals?: TourMegaReportAmountsModel | undefined;
    tourCostTotals?: TourMegaReportAmountsModel | undefined;
    tourProfit?: TourMegaReportAmountsModel | undefined;
    merchIncomeTotals?: TourMegaReportAmountsModel | undefined;
    merchCostTotals?: TourMegaReportAmountsModel | undefined;
    merchProfit?: TourMegaReportAmountsModel | undefined;
    netProfit?: TourMegaReportAmountsModel | undefined;
}

export class TourMegaReportDataModel implements ITourMegaReportDataModel {
    artistAverages?: TourMegaReportAverages | undefined;
    tourAverages?: TourMegaReportAverages | undefined;
    shows?: TourMegaReportShowModel[] | undefined;
    tourCostCategories?: TourMegaReportTourCategoryModel[] | undefined;
    tourIncomeCategories?: TourMegaReportTourCategoryModel[] | undefined;
    merchCosts?: TourMegaReportTourCategoryModel | undefined;

    constructor(data?: ITourMegaReportDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.artistAverages = _data["artistAverages"] ? TourMegaReportAverages.fromJS(_data["artistAverages"]) : <any>undefined;
            this.tourAverages = _data["tourAverages"] ? TourMegaReportAverages.fromJS(_data["tourAverages"]) : <any>undefined;
            if (Array.isArray(_data["shows"])) {
                this.shows = [] as any;
                for (let item of _data["shows"])
                    this.shows.push(TourMegaReportShowModel.fromJS(item));
            }
            if (Array.isArray(_data["tourCostCategories"])) {
                this.tourCostCategories = [] as any;
                for (let item of _data["tourCostCategories"])
                    this.tourCostCategories.push(TourMegaReportTourCategoryModel.fromJS(item));
            }
            if (Array.isArray(_data["tourIncomeCategories"])) {
                this.tourIncomeCategories = [] as any;
                for (let item of _data["tourIncomeCategories"])
                    this.tourIncomeCategories.push(TourMegaReportTourCategoryModel.fromJS(item));
            }
            this.merchCosts = _data["merchCosts"] ? TourMegaReportTourCategoryModel.fromJS(_data["merchCosts"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TourMegaReportDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourMegaReportDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["artistAverages"] = this.artistAverages ? this.artistAverages.toJSON() : <any>undefined;
        data["tourAverages"] = this.tourAverages ? this.tourAverages.toJSON() : <any>undefined;
        if (Array.isArray(this.shows)) {
            data["shows"] = [];
            for (let item of this.shows)
                data["shows"].push(item.toJSON());
        }
        if (Array.isArray(this.tourCostCategories)) {
            data["tourCostCategories"] = [];
            for (let item of this.tourCostCategories)
                data["tourCostCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.tourIncomeCategories)) {
            data["tourIncomeCategories"] = [];
            for (let item of this.tourIncomeCategories)
                data["tourIncomeCategories"].push(item.toJSON());
        }
        data["merchCosts"] = this.merchCosts ? this.merchCosts.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITourMegaReportDataModel {
    artistAverages?: TourMegaReportAverages | undefined;
    tourAverages?: TourMegaReportAverages | undefined;
    shows?: TourMegaReportShowModel[] | undefined;
    tourCostCategories?: TourMegaReportTourCategoryModel[] | undefined;
    tourIncomeCategories?: TourMegaReportTourCategoryModel[] | undefined;
    merchCosts?: TourMegaReportTourCategoryModel | undefined;
}

export class TourMegaReportAverages implements ITourMegaReportAverages {
    ticketSellRatio: number;
    merchIncomePerShow: number;
    merchIncomePerHead: number;
    categorys?: TourMegaCategoryAmount[] | undefined;
    categoryShowAvg?: TourMegaCategoryAmount[] | undefined;

    constructor(data?: ITourMegaReportAverages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketSellRatio = _data["ticketSellRatio"];
            this.merchIncomePerShow = _data["merchIncomePerShow"];
            this.merchIncomePerHead = _data["merchIncomePerHead"];
            if (Array.isArray(_data["categorys"])) {
                this.categorys = [] as any;
                for (let item of _data["categorys"])
                    this.categorys.push(TourMegaCategoryAmount.fromJS(item));
            }
            if (Array.isArray(_data["categoryShowAvg"])) {
                this.categoryShowAvg = [] as any;
                for (let item of _data["categoryShowAvg"])
                    this.categoryShowAvg.push(TourMegaCategoryAmount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TourMegaReportAverages {
        data = typeof data === 'object' ? data : {};
        let result = new TourMegaReportAverages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketSellRatio"] = this.ticketSellRatio;
        data["merchIncomePerShow"] = this.merchIncomePerShow;
        data["merchIncomePerHead"] = this.merchIncomePerHead;
        if (Array.isArray(this.categorys)) {
            data["categorys"] = [];
            for (let item of this.categorys)
                data["categorys"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryShowAvg)) {
            data["categoryShowAvg"] = [];
            for (let item of this.categoryShowAvg)
                data["categoryShowAvg"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITourMegaReportAverages {
    ticketSellRatio: number;
    merchIncomePerShow: number;
    merchIncomePerHead: number;
    categorys?: TourMegaCategoryAmount[] | undefined;
    categoryShowAvg?: TourMegaCategoryAmount[] | undefined;
}

export class TourMegaCategoryAmount implements ITourMegaCategoryAmount {
    category?: string | undefined;
    ratioOfTourIncome: number;
    amount: number;

    constructor(data?: ITourMegaCategoryAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.ratioOfTourIncome = _data["ratioOfTourIncome"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): TourMegaCategoryAmount {
        data = typeof data === 'object' ? data : {};
        let result = new TourMegaCategoryAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["ratioOfTourIncome"] = this.ratioOfTourIncome;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface ITourMegaCategoryAmount {
    category?: string | undefined;
    ratioOfTourIncome: number;
    amount: number;
}

export class TourMegaReportShowModel implements ITourMegaReportShowModel {
    id: string;
    venue?: VenueModel | undefined;
    dateISO?: string | undefined;
    showType?: string | undefined;
    ticketSell: number;
    ticketPrice: number;
    capacity: number;
    dealType?: BudgetShowDealTypeEnum | undefined;
    flatFeeIncome?: number | undefined;
    guaranteeIncome?: number | undefined;
    artistSharePercent?: number | undefined;
    promoterPercentage?: number | undefined;
    artistBonusTicketThreshold: number;
    promoterDealArtistBonus?: number | undefined;
    income?: TourMegaReportTourCategoryModel[] | undefined;
    costs?: TourMegaReportTourCategoryModel[] | undefined;
    incomeTotals?: TourMegaReportAmountsModel | undefined;
    costTotals?: TourMegaReportAmountsModel | undefined;
    merchCostTotals?: TourMegaReportAmountsModel | undefined;
    merchIncomeTotals?: TourMegaReportAmountsModel | undefined;

    constructor(data?: ITourMegaReportShowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.venue = _data["venue"] ? VenueModel.fromJS(_data["venue"]) : <any>undefined;
            this.dateISO = _data["dateISO"];
            this.showType = _data["showType"];
            this.ticketSell = _data["ticketSell"];
            this.ticketPrice = _data["ticketPrice"];
            this.capacity = _data["capacity"];
            this.dealType = _data["dealType"];
            this.flatFeeIncome = _data["flatFeeIncome"];
            this.guaranteeIncome = _data["guaranteeIncome"];
            this.artistSharePercent = _data["artistSharePercent"];
            this.promoterPercentage = _data["promoterPercentage"];
            this.artistBonusTicketThreshold = _data["artistBonusTicketThreshold"];
            this.promoterDealArtistBonus = _data["promoterDealArtistBonus"];
            if (Array.isArray(_data["income"])) {
                this.income = [] as any;
                for (let item of _data["income"])
                    this.income.push(TourMegaReportTourCategoryModel.fromJS(item));
            }
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs.push(TourMegaReportTourCategoryModel.fromJS(item));
            }
            this.incomeTotals = _data["incomeTotals"] ? TourMegaReportAmountsModel.fromJS(_data["incomeTotals"]) : <any>undefined;
            this.costTotals = _data["costTotals"] ? TourMegaReportAmountsModel.fromJS(_data["costTotals"]) : <any>undefined;
            this.merchCostTotals = _data["merchCostTotals"] ? TourMegaReportAmountsModel.fromJS(_data["merchCostTotals"]) : <any>undefined;
            this.merchIncomeTotals = _data["merchIncomeTotals"] ? TourMegaReportAmountsModel.fromJS(_data["merchIncomeTotals"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TourMegaReportShowModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourMegaReportShowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        data["dateISO"] = this.dateISO;
        data["showType"] = this.showType;
        data["ticketSell"] = this.ticketSell;
        data["ticketPrice"] = this.ticketPrice;
        data["capacity"] = this.capacity;
        data["dealType"] = this.dealType;
        data["flatFeeIncome"] = this.flatFeeIncome;
        data["guaranteeIncome"] = this.guaranteeIncome;
        data["artistSharePercent"] = this.artistSharePercent;
        data["promoterPercentage"] = this.promoterPercentage;
        data["artistBonusTicketThreshold"] = this.artistBonusTicketThreshold;
        data["promoterDealArtistBonus"] = this.promoterDealArtistBonus;
        if (Array.isArray(this.income)) {
            data["income"] = [];
            for (let item of this.income)
                data["income"].push(item.toJSON());
        }
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item.toJSON());
        }
        data["incomeTotals"] = this.incomeTotals ? this.incomeTotals.toJSON() : <any>undefined;
        data["costTotals"] = this.costTotals ? this.costTotals.toJSON() : <any>undefined;
        data["merchCostTotals"] = this.merchCostTotals ? this.merchCostTotals.toJSON() : <any>undefined;
        data["merchIncomeTotals"] = this.merchIncomeTotals ? this.merchIncomeTotals.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITourMegaReportShowModel {
    id: string;
    venue?: VenueModel | undefined;
    dateISO?: string | undefined;
    showType?: string | undefined;
    ticketSell: number;
    ticketPrice: number;
    capacity: number;
    dealType?: BudgetShowDealTypeEnum | undefined;
    flatFeeIncome?: number | undefined;
    guaranteeIncome?: number | undefined;
    artistSharePercent?: number | undefined;
    promoterPercentage?: number | undefined;
    artistBonusTicketThreshold: number;
    promoterDealArtistBonus?: number | undefined;
    income?: TourMegaReportTourCategoryModel[] | undefined;
    costs?: TourMegaReportTourCategoryModel[] | undefined;
    incomeTotals?: TourMegaReportAmountsModel | undefined;
    costTotals?: TourMegaReportAmountsModel | undefined;
    merchCostTotals?: TourMegaReportAmountsModel | undefined;
    merchIncomeTotals?: TourMegaReportAmountsModel | undefined;
}

export class TourMegaReportTourCategoryModel implements ITourMegaReportTourCategoryModel {
    category?: string | undefined;
    totals?: TourMegaReportAmountsModel | undefined;
    subCategories?: TourMegaReportSubCategoryModel[] | undefined;

    constructor(data?: ITourMegaReportTourCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.totals = _data["totals"] ? TourMegaReportAmountsModel.fromJS(_data["totals"]) : <any>undefined;
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [] as any;
                for (let item of _data["subCategories"])
                    this.subCategories.push(TourMegaReportSubCategoryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TourMegaReportTourCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourMegaReportTourCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (let item of this.subCategories)
                data["subCategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITourMegaReportTourCategoryModel {
    category?: string | undefined;
    totals?: TourMegaReportAmountsModel | undefined;
    subCategories?: TourMegaReportSubCategoryModel[] | undefined;
}

export class TourMegaReportAmountsModel implements ITourMegaReportAmountsModel {
    budgeted?: number | undefined;
    actual: number;

    constructor(data?: ITourMegaReportAmountsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgeted = _data["budgeted"];
            this.actual = _data["actual"];
        }
    }

    static fromJS(data: any): TourMegaReportAmountsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourMegaReportAmountsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgeted"] = this.budgeted;
        data["actual"] = this.actual;
        return data; 
    }
}

export interface ITourMegaReportAmountsModel {
    budgeted?: number | undefined;
    actual: number;
}

export class TourMegaReportSubCategoryModel implements ITourMegaReportSubCategoryModel {
    subCategory?: string | undefined;
    notes?: string | undefined;
    showId?: string | undefined;
    totals?: TourMegaReportAmountsModel | undefined;

    constructor(data?: ITourMegaReportSubCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCategory = _data["subCategory"];
            this.notes = _data["notes"];
            this.showId = _data["showId"];
            this.totals = _data["totals"] ? TourMegaReportAmountsModel.fromJS(_data["totals"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TourMegaReportSubCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourMegaReportSubCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCategory"] = this.subCategory;
        data["notes"] = this.notes;
        data["showId"] = this.showId;
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITourMegaReportSubCategoryModel {
    subCategory?: string | undefined;
    notes?: string | undefined;
    showId?: string | undefined;
    totals?: TourMegaReportAmountsModel | undefined;
}

export class TransactionModel implements ITransactionModel {
    id: string;
    dateString?: string | undefined;
    reference?: string | undefined;
    merchantName?: string | undefined;
    notes?: string | undefined;
    amount: number;
    category?: string | undefined;
    subCategory?: string | undefined;
    type: TransactionType;
    currencyCode?: string | undefined;
    showAllocationCalculation: AllocationCalculationType;

    constructor(data?: ITransactionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateString = _data["dateString"];
            this.reference = _data["reference"];
            this.merchantName = _data["merchantName"];
            this.notes = _data["notes"];
            this.amount = _data["amount"];
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.type = _data["type"];
            this.currencyCode = _data["currencyCode"];
            this.showAllocationCalculation = _data["showAllocationCalculation"];
        }
    }

    static fromJS(data: any): TransactionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateString"] = this.dateString;
        data["reference"] = this.reference;
        data["merchantName"] = this.merchantName;
        data["notes"] = this.notes;
        data["amount"] = this.amount;
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["type"] = this.type;
        data["currencyCode"] = this.currencyCode;
        data["showAllocationCalculation"] = this.showAllocationCalculation;
        return data; 
    }
}

export interface ITransactionModel {
    id: string;
    dateString?: string | undefined;
    reference?: string | undefined;
    merchantName?: string | undefined;
    notes?: string | undefined;
    amount: number;
    category?: string | undefined;
    subCategory?: string | undefined;
    type: TransactionType;
    currencyCode?: string | undefined;
    showAllocationCalculation: AllocationCalculationType;
}

export enum AllocationCalculationType {
    None = 0,
    Manual = 1,
    Split = 2,
    ProportionalOfIncome = 3,
}

export class QuickBooksAuthResponseModel implements IQuickBooksAuthResponseModel {
    accessToken?: string | undefined;
    accessTokenExpiresInSeconds: number;
    refreshToken?: string | undefined;
    refreshTokenExpiresInSeconds: number;

    constructor(data?: IQuickBooksAuthResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenExpiresInSeconds = _data["accessTokenExpiresInSeconds"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiresInSeconds = _data["refreshTokenExpiresInSeconds"];
        }
    }

    static fromJS(data: any): QuickBooksAuthResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuickBooksAuthResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenExpiresInSeconds"] = this.accessTokenExpiresInSeconds;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiresInSeconds"] = this.refreshTokenExpiresInSeconds;
        return data; 
    }
}

export interface IQuickBooksAuthResponseModel {
    accessToken?: string | undefined;
    accessTokenExpiresInSeconds: number;
    refreshToken?: string | undefined;
    refreshTokenExpiresInSeconds: number;
}

export class TransactionImportModel implements ITransactionImportModel {
    id: string;
    dateString?: string | undefined;
    reference?: string | undefined;
    merchantName?: string | undefined;
    notes?: string | undefined;
    amount: number;
    subCategory?: string | undefined;
    category?: string | undefined;

    constructor(data?: ITransactionImportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateString = _data["dateString"];
            this.reference = _data["reference"];
            this.merchantName = _data["merchantName"];
            this.notes = _data["notes"];
            this.amount = _data["amount"];
            this.subCategory = _data["subCategory"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): TransactionImportModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionImportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateString"] = this.dateString;
        data["reference"] = this.reference;
        data["merchantName"] = this.merchantName;
        data["notes"] = this.notes;
        data["amount"] = this.amount;
        data["subCategory"] = this.subCategory;
        data["category"] = this.category;
        return data; 
    }
}

export interface ITransactionImportModel {
    id: string;
    dateString?: string | undefined;
    reference?: string | undefined;
    merchantName?: string | undefined;
    notes?: string | undefined;
    amount: number;
    subCategory?: string | undefined;
    category?: string | undefined;
}

export class ArtistSubscriptionPlanSummaryModel implements IArtistSubscriptionPlanSummaryModel {
    productId?: string | undefined;
    planId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    interval?: string | undefined;
    amount: number;
    currency?: string | undefined;

    constructor(data?: IArtistSubscriptionPlanSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.planId = _data["planId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.interval = _data["interval"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): ArtistSubscriptionPlanSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistSubscriptionPlanSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["planId"] = this.planId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["interval"] = this.interval;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        return data; 
    }
}

export interface IArtistSubscriptionPlanSummaryModel {
    productId?: string | undefined;
    planId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    interval?: string | undefined;
    amount: number;
    currency?: string | undefined;
}

export class ArtistSubscriptionStatusModel implements IArtistSubscriptionStatusModel {
    access?: ArtistSubscriptionAccessEnum[] | undefined;
    status: SubscriptionStatusEnum;
    freePlanDescription?: string | undefined;
    freePlanFeaturesDescription?: string | undefined;
    trialFinishesUtc: Date;
    subscription?: ArtistStripeSubscriptionStatusModel | undefined;

    constructor(data?: IArtistSubscriptionStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["access"])) {
                this.access = [] as any;
                for (let item of _data["access"])
                    this.access.push(item);
            }
            this.status = _data["status"];
            this.freePlanDescription = _data["freePlanDescription"];
            this.freePlanFeaturesDescription = _data["freePlanFeaturesDescription"];
            this.trialFinishesUtc = _data["trialFinishesUtc"] ? new Date(_data["trialFinishesUtc"].toString()) : <any>undefined;
            this.subscription = _data["subscription"] ? ArtistStripeSubscriptionStatusModel.fromJS(_data["subscription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArtistSubscriptionStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistSubscriptionStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.access)) {
            data["access"] = [];
            for (let item of this.access)
                data["access"].push(item);
        }
        data["status"] = this.status;
        data["freePlanDescription"] = this.freePlanDescription;
        data["freePlanFeaturesDescription"] = this.freePlanFeaturesDescription;
        data["trialFinishesUtc"] = this.trialFinishesUtc ? this.trialFinishesUtc.toISOString() : <any>undefined;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IArtistSubscriptionStatusModel {
    access?: ArtistSubscriptionAccessEnum[] | undefined;
    status: SubscriptionStatusEnum;
    freePlanDescription?: string | undefined;
    freePlanFeaturesDescription?: string | undefined;
    trialFinishesUtc: Date;
    subscription?: ArtistStripeSubscriptionStatusModel | undefined;
}

export enum ArtistSubscriptionAccessEnum {
    Budget = 1,
    Financials = 2,
    MultiUser = 10,
    Multicurrency = 11,
    BudgetApprovals = 50,
    ArtistReport = 70,
    SearchShowsReport = 71,
}

export enum SubscriptionStatusEnum {
    Active = 0,
    Trialing = 1,
    Free = 2,
    FreePlan = 3,
    PastDue = 4,
    Unpaid = 5,
    TrialNotStarted = 6,
    TrialOver = 7,
    Unknown = 8,
}

export class ArtistStripeSubscriptionStatusModel implements IArtistStripeSubscriptionStatusModel {
    id?: string | undefined;
    product?: SubscriptionStatusProductSummaryModel | undefined;
    plan?: SubscriptionStatusPlanSummaryModel | undefined;
    expires?: Date | undefined;
    discountName?: string | undefined;
    email?: string | undefined;
    trialStart?: Date | undefined;
    currentPeriodEnd?: Date | undefined;
    currentPeriodStart?: Date | undefined;
    card?: CreditCardModel | undefined;

    constructor(data?: IArtistStripeSubscriptionStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.product = _data["product"] ? SubscriptionStatusProductSummaryModel.fromJS(_data["product"]) : <any>undefined;
            this.plan = _data["plan"] ? SubscriptionStatusPlanSummaryModel.fromJS(_data["plan"]) : <any>undefined;
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
            this.discountName = _data["discountName"];
            this.email = _data["email"];
            this.trialStart = _data["trialStart"] ? new Date(_data["trialStart"].toString()) : <any>undefined;
            this.currentPeriodEnd = _data["currentPeriodEnd"] ? new Date(_data["currentPeriodEnd"].toString()) : <any>undefined;
            this.currentPeriodStart = _data["currentPeriodStart"] ? new Date(_data["currentPeriodStart"].toString()) : <any>undefined;
            this.card = _data["card"] ? CreditCardModel.fromJS(_data["card"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArtistStripeSubscriptionStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistStripeSubscriptionStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["plan"] = this.plan ? this.plan.toJSON() : <any>undefined;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["discountName"] = this.discountName;
        data["email"] = this.email;
        data["trialStart"] = this.trialStart ? this.trialStart.toISOString() : <any>undefined;
        data["currentPeriodEnd"] = this.currentPeriodEnd ? this.currentPeriodEnd.toISOString() : <any>undefined;
        data["currentPeriodStart"] = this.currentPeriodStart ? this.currentPeriodStart.toISOString() : <any>undefined;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IArtistStripeSubscriptionStatusModel {
    id?: string | undefined;
    product?: SubscriptionStatusProductSummaryModel | undefined;
    plan?: SubscriptionStatusPlanSummaryModel | undefined;
    expires?: Date | undefined;
    discountName?: string | undefined;
    email?: string | undefined;
    trialStart?: Date | undefined;
    currentPeriodEnd?: Date | undefined;
    currentPeriodStart?: Date | undefined;
    card?: CreditCardModel | undefined;
}

export class SubscriptionStatusProductSummaryModel implements ISubscriptionStatusProductSummaryModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISubscriptionStatusProductSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SubscriptionStatusProductSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionStatusProductSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface ISubscriptionStatusProductSummaryModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class SubscriptionStatusPlanSummaryModel implements ISubscriptionStatusPlanSummaryModel {
    id?: string | undefined;
    amount: number;
    currency?: string | undefined;
    interval?: string | undefined;

    constructor(data?: ISubscriptionStatusPlanSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.interval = _data["interval"];
        }
    }

    static fromJS(data: any): SubscriptionStatusPlanSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionStatusPlanSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["interval"] = this.interval;
        return data; 
    }
}

export interface ISubscriptionStatusPlanSummaryModel {
    id?: string | undefined;
    amount: number;
    currency?: string | undefined;
    interval?: string | undefined;
}

export class CreditCardModel implements ICreditCardModel {
    number?: string | undefined;
    name?: string | undefined;
    expiry?: string | undefined;
    brand?: string | undefined;

    constructor(data?: ICreditCardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.name = _data["name"];
            this.expiry = _data["expiry"];
            this.brand = _data["brand"];
        }
    }

    static fromJS(data: any): CreditCardModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["name"] = this.name;
        data["expiry"] = this.expiry;
        data["brand"] = this.brand;
        return data; 
    }
}

export interface ICreditCardModel {
    number?: string | undefined;
    name?: string | undefined;
    expiry?: string | undefined;
    brand?: string | undefined;
}

export class ArtistSubscriptionSetPlanModel implements IArtistSubscriptionSetPlanModel {
    planId?: string | undefined;
    email?: string | undefined;
    couponCode?: string | undefined;

    constructor(data?: IArtistSubscriptionSetPlanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planId = _data["planId"];
            this.email = _data["email"];
            this.couponCode = _data["couponCode"];
        }
    }

    static fromJS(data: any): ArtistSubscriptionSetPlanModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistSubscriptionSetPlanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        data["email"] = this.email;
        data["couponCode"] = this.couponCode;
        return data; 
    }
}

export interface IArtistSubscriptionSetPlanModel {
    planId?: string | undefined;
    email?: string | undefined;
    couponCode?: string | undefined;
}

export class ArtistSubscriptionSubscribeModel implements IArtistSubscriptionSubscribeModel {
    email?: string | undefined;
    token?: string | undefined;
    planId?: string | undefined;
    couponCode?: string | undefined;

    constructor(data?: IArtistSubscriptionSubscribeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.planId = _data["planId"];
            this.couponCode = _data["couponCode"];
        }
    }

    static fromJS(data: any): ArtistSubscriptionSubscribeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistSubscriptionSubscribeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["planId"] = this.planId;
        data["couponCode"] = this.couponCode;
        return data; 
    }
}

export interface IArtistSubscriptionSubscribeModel {
    email?: string | undefined;
    token?: string | undefined;
    planId?: string | undefined;
    couponCode?: string | undefined;
}

export class ArtistSubscriptionStartTrialModel implements IArtistSubscriptionStartTrialModel {
    couponCode?: string | undefined;

    constructor(data?: IArtistSubscriptionStartTrialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.couponCode = _data["couponCode"];
        }
    }

    static fromJS(data: any): ArtistSubscriptionStartTrialModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistSubscriptionStartTrialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["couponCode"] = this.couponCode;
        return data; 
    }
}

export interface IArtistSubscriptionStartTrialModel {
    couponCode?: string | undefined;
}

export class ArtistSubscriptionCreditCardUpdateModel implements IArtistSubscriptionCreditCardUpdateModel {
    email?: string | undefined;
    token?: string | undefined;

    constructor(data?: IArtistSubscriptionCreditCardUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ArtistSubscriptionCreditCardUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistSubscriptionCreditCardUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        return data; 
    }
}

export interface IArtistSubscriptionCreditCardUpdateModel {
    email?: string | undefined;
    token?: string | undefined;
}

export class SubscriptionInvoiceModel implements ISubscriptionInvoiceModel {
    number?: string | undefined;
    billedOn: Date;
    status?: string | undefined;
    pdfUrl?: string | undefined;

    constructor(data?: ISubscriptionInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.billedOn = _data["billedOn"] ? new Date(_data["billedOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.pdfUrl = _data["pdfUrl"];
        }
    }

    static fromJS(data: any): SubscriptionInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["billedOn"] = this.billedOn ? this.billedOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["pdfUrl"] = this.pdfUrl;
        return data; 
    }
}

export interface ISubscriptionInvoiceModel {
    number?: string | undefined;
    billedOn: Date;
    status?: string | undefined;
    pdfUrl?: string | undefined;
}

export class ClientConfig implements IClientConfig {
    auth0ClientId?: string | undefined;
    auth0Domain?: string | undefined;
    auth0RedirectUri?: string | undefined;
    auth0Audience?: string | undefined;
    appInsightsKey?: string | undefined;
    googleKey?: string | undefined;
    googleAnalyticsId?: string | undefined;
    fullStoryOrgId?: string | undefined;
    stripePublicKey?: string | undefined;

    constructor(data?: IClientConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auth0ClientId = _data["auth0ClientId"];
            this.auth0Domain = _data["auth0Domain"];
            this.auth0RedirectUri = _data["auth0RedirectUri"];
            this.auth0Audience = _data["auth0Audience"];
            this.appInsightsKey = _data["appInsightsKey"];
            this.googleKey = _data["googleKey"];
            this.googleAnalyticsId = _data["googleAnalyticsId"];
            this.fullStoryOrgId = _data["fullStoryOrgId"];
            this.stripePublicKey = _data["stripePublicKey"];
        }
    }

    static fromJS(data: any): ClientConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ClientConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auth0ClientId"] = this.auth0ClientId;
        data["auth0Domain"] = this.auth0Domain;
        data["auth0RedirectUri"] = this.auth0RedirectUri;
        data["auth0Audience"] = this.auth0Audience;
        data["appInsightsKey"] = this.appInsightsKey;
        data["googleKey"] = this.googleKey;
        data["googleAnalyticsId"] = this.googleAnalyticsId;
        data["fullStoryOrgId"] = this.fullStoryOrgId;
        data["stripePublicKey"] = this.stripePublicKey;
        return data; 
    }
}

export interface IClientConfig {
    auth0ClientId?: string | undefined;
    auth0Domain?: string | undefined;
    auth0RedirectUri?: string | undefined;
    auth0Audience?: string | undefined;
    appInsightsKey?: string | undefined;
    googleKey?: string | undefined;
    googleAnalyticsId?: string | undefined;
    fullStoryOrgId?: string | undefined;
    stripePublicKey?: string | undefined;
}

export class BudgetToolPresetModel implements IBudgetToolPresetModel {
    contingencies?: { [key: string]: ContingencyBudgetModel; } | undefined;
    subcategories?: { [key: string]: SubcategoryBudgetModel[]; } | undefined;
    commissions?: CommissionsCostModel[] | undefined;
    personnel?: PersonnelTemplateBudgetModel[] | undefined;

    constructor(data?: IBudgetToolPresetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["contingencies"]) {
                this.contingencies = {} as any;
                for (let key in _data["contingencies"]) {
                    if (_data["contingencies"].hasOwnProperty(key))
                        this.contingencies[key] = _data["contingencies"][key] ? ContingencyBudgetModel.fromJS(_data["contingencies"][key]) : new ContingencyBudgetModel();
                }
            }
            if (_data["subcategories"]) {
                this.subcategories = {} as any;
                for (let key in _data["subcategories"]) {
                    if (_data["subcategories"].hasOwnProperty(key))
                        this.subcategories[key] = _data["subcategories"][key] ? _data["subcategories"][key].map((i: any) => SubcategoryBudgetModel.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["commissions"])) {
                this.commissions = [] as any;
                for (let item of _data["commissions"])
                    this.commissions.push(CommissionsCostModel.fromJS(item));
            }
            if (Array.isArray(_data["personnel"])) {
                this.personnel = [] as any;
                for (let item of _data["personnel"])
                    this.personnel.push(PersonnelTemplateBudgetModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetToolPresetModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetToolPresetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.contingencies) {
            data["contingencies"] = {};
            for (let key in this.contingencies) {
                if (this.contingencies.hasOwnProperty(key))
                    data["contingencies"][key] = this.contingencies[key] ? this.contingencies[key].toJSON() : <any>undefined;
            }
        }
        if (this.subcategories) {
            data["subcategories"] = {};
            for (let key in this.subcategories) {
                if (this.subcategories.hasOwnProperty(key))
                    data["subcategories"][key] = this.subcategories[key];
            }
        }
        if (Array.isArray(this.commissions)) {
            data["commissions"] = [];
            for (let item of this.commissions)
                data["commissions"].push(item.toJSON());
        }
        if (Array.isArray(this.personnel)) {
            data["personnel"] = [];
            for (let item of this.personnel)
                data["personnel"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBudgetToolPresetModel {
    contingencies?: { [key: string]: ContingencyBudgetModel; } | undefined;
    subcategories?: { [key: string]: SubcategoryBudgetModel[]; } | undefined;
    commissions?: CommissionsCostModel[] | undefined;
    personnel?: PersonnelTemplateBudgetModel[] | undefined;
}

export class PersonnelTemplateBudgetModel implements IPersonnelTemplateBudgetModel {
    name?: string | undefined;
    subcategory?: string | undefined;
    currencyCode?: string | undefined;
    sequence: number;
    fromPresetId?: string | undefined;
    personPresetIdentifier?: string | undefined;
    showDayRate?: PersonnelDayRateBudgetModel | undefined;
    nonShowDayRate?: PersonnelDayRateBudgetModel | undefined;
    mealAllowance?: PersonnelDayRateBudgetModel | undefined;
    preTourFlatFee: number;
    payrollTax?: PersonnelDayRateBudgetModel | undefined;

    constructor(data?: IPersonnelTemplateBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.subcategory = _data["subcategory"];
            this.currencyCode = _data["currencyCode"];
            this.sequence = _data["sequence"];
            this.fromPresetId = _data["fromPresetId"];
            this.personPresetIdentifier = _data["personPresetIdentifier"];
            this.showDayRate = _data["showDayRate"] ? PersonnelDayRateBudgetModel.fromJS(_data["showDayRate"]) : <any>undefined;
            this.nonShowDayRate = _data["nonShowDayRate"] ? PersonnelDayRateBudgetModel.fromJS(_data["nonShowDayRate"]) : <any>undefined;
            this.mealAllowance = _data["mealAllowance"] ? PersonnelDayRateBudgetModel.fromJS(_data["mealAllowance"]) : <any>undefined;
            this.preTourFlatFee = _data["preTourFlatFee"];
            this.payrollTax = _data["payrollTax"] ? PersonnelDayRateBudgetModel.fromJS(_data["payrollTax"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonnelTemplateBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonnelTemplateBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["subcategory"] = this.subcategory;
        data["currencyCode"] = this.currencyCode;
        data["sequence"] = this.sequence;
        data["fromPresetId"] = this.fromPresetId;
        data["personPresetIdentifier"] = this.personPresetIdentifier;
        data["showDayRate"] = this.showDayRate ? this.showDayRate.toJSON() : <any>undefined;
        data["nonShowDayRate"] = this.nonShowDayRate ? this.nonShowDayRate.toJSON() : <any>undefined;
        data["mealAllowance"] = this.mealAllowance ? this.mealAllowance.toJSON() : <any>undefined;
        data["preTourFlatFee"] = this.preTourFlatFee;
        data["payrollTax"] = this.payrollTax ? this.payrollTax.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPersonnelTemplateBudgetModel {
    name?: string | undefined;
    subcategory?: string | undefined;
    currencyCode?: string | undefined;
    sequence: number;
    fromPresetId?: string | undefined;
    personPresetIdentifier?: string | undefined;
    showDayRate?: PersonnelDayRateBudgetModel | undefined;
    nonShowDayRate?: PersonnelDayRateBudgetModel | undefined;
    mealAllowance?: PersonnelDayRateBudgetModel | undefined;
    preTourFlatFee: number;
    payrollTax?: PersonnelDayRateBudgetModel | undefined;
}

export class BudgetingToolSummaryModel implements IBudgetingToolSummaryModel {
    id: string;
    name?: string | undefined;

    constructor(data?: IBudgetingToolSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BudgetingToolSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetingToolSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IBudgetingToolSummaryModel {
    id: string;
    name?: string | undefined;
}

export enum BudgetSaveResult {
    OK = 0,
    Locked = 1,
}

export class AddPresetsFromBudgetModel implements IAddPresetsFromBudgetModel {
    contingency?: ContingencyBudgetModel | undefined;
    subcategories?: SubcategoryBudgetModel[] | undefined;
    category?: string | undefined;

    constructor(data?: IAddPresetsFromBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contingency = _data["contingency"] ? ContingencyBudgetModel.fromJS(_data["contingency"]) : <any>undefined;
            if (Array.isArray(_data["subcategories"])) {
                this.subcategories = [] as any;
                for (let item of _data["subcategories"])
                    this.subcategories.push(SubcategoryBudgetModel.fromJS(item));
            }
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): AddPresetsFromBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddPresetsFromBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contingency"] = this.contingency ? this.contingency.toJSON() : <any>undefined;
        if (Array.isArray(this.subcategories)) {
            data["subcategories"] = [];
            for (let item of this.subcategories)
                data["subcategories"].push(item.toJSON());
        }
        data["category"] = this.category;
        return data; 
    }
}

export interface IAddPresetsFromBudgetModel {
    contingency?: ContingencyBudgetModel | undefined;
    subcategories?: SubcategoryBudgetModel[] | undefined;
    category?: string | undefined;
}

export class AddPresetCommissionsFromBudgetModel implements IAddPresetCommissionsFromBudgetModel {
    commissions?: CommissionsCostModel[] | undefined;

    constructor(data?: IAddPresetCommissionsFromBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["commissions"])) {
                this.commissions = [] as any;
                for (let item of _data["commissions"])
                    this.commissions.push(CommissionsCostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddPresetCommissionsFromBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddPresetCommissionsFromBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commissions)) {
            data["commissions"] = [];
            for (let item of this.commissions)
                data["commissions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAddPresetCommissionsFromBudgetModel {
    commissions?: CommissionsCostModel[] | undefined;
}

export class AddPresetPersonnelFromBudgetModel implements IAddPresetPersonnelFromBudgetModel {
    person?: PersonnelBudgetModel | undefined;
    subcategory?: SubcategoryBudgetModel | undefined;

    constructor(data?: IAddPresetPersonnelFromBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? PersonnelBudgetModel.fromJS(_data["person"]) : <any>undefined;
            this.subcategory = _data["subcategory"] ? SubcategoryBudgetModel.fromJS(_data["subcategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPresetPersonnelFromBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddPresetPersonnelFromBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["subcategory"] = this.subcategory ? this.subcategory.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPresetPersonnelFromBudgetModel {
    person?: PersonnelBudgetModel | undefined;
    subcategory?: SubcategoryBudgetModel | undefined;
}

export class ApproveBudgetModel implements IApproveBudgetModel {
    userName?: string | undefined;
    email?: string | undefined;
    userPictureUrl?: string | undefined;
    budgetImageData?: string | undefined;

    constructor(data?: IApproveBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.userPictureUrl = _data["userPictureUrl"];
            this.budgetImageData = _data["budgetImageData"];
        }
    }

    static fromJS(data: any): ApproveBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["userPictureUrl"] = this.userPictureUrl;
        data["budgetImageData"] = this.budgetImageData;
        return data; 
    }
}

export interface IApproveBudgetModel {
    userName?: string | undefined;
    email?: string | undefined;
    userPictureUrl?: string | undefined;
    budgetImageData?: string | undefined;
}

export class BudgetApprovalSummaryModel implements IBudgetApprovalSummaryModel {
    id: string;
    dateISOUtc?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    userPictureUrl?: string | undefined;

    constructor(data?: IBudgetApprovalSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateISOUtc = _data["dateISOUtc"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.userPictureUrl = _data["userPictureUrl"];
        }
    }

    static fromJS(data: any): BudgetApprovalSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetApprovalSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateISOUtc"] = this.dateISOUtc;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["userPictureUrl"] = this.userPictureUrl;
        return data; 
    }
}

export interface IBudgetApprovalSummaryModel {
    id: string;
    dateISOUtc?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
    userPictureUrl?: string | undefined;
}

export class TourCreateModel implements ITourCreateModel {
    name?: string | undefined;
    currencyCode?: string | undefined;
    artistExchangeRate: number;
    usdExchangeRate: number;
    usePresets: boolean;

    constructor(data?: ITourCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.currencyCode = _data["currencyCode"];
            this.artistExchangeRate = _data["artistExchangeRate"];
            this.usdExchangeRate = _data["usdExchangeRate"];
            this.usePresets = _data["usePresets"];
        }
    }

    static fromJS(data: any): TourCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["currencyCode"] = this.currencyCode;
        data["artistExchangeRate"] = this.artistExchangeRate;
        data["usdExchangeRate"] = this.usdExchangeRate;
        data["usePresets"] = this.usePresets;
        return data; 
    }
}

export interface ITourCreateModel {
    name?: string | undefined;
    currencyCode?: string | undefined;
    artistExchangeRate: number;
    usdExchangeRate: number;
    usePresets: boolean;
}

export class TourUpdateModel implements ITourUpdateModel {
    name?: string | undefined;
    notes?: string | undefined;
    artistExchangeRate: number;

    constructor(data?: ITourUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.artistExchangeRate = _data["artistExchangeRate"];
        }
    }

    static fromJS(data: any): TourUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["artistExchangeRate"] = this.artistExchangeRate;
        return data; 
    }
}

export interface ITourUpdateModel {
    name?: string | undefined;
    notes?: string | undefined;
    artistExchangeRate: number;
}

export class TourSummaryModel implements ITourSummaryModel {
    id: string;
    name?: string | undefined;
    currencyCode?: string | undefined;
    showCount: number;
    firstDateISO?: string | undefined;
    lastDateISO?: string | undefined;
    budgetSummaries?: TourSummaryBudgetModel[] | undefined;

    constructor(data?: ITourSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.currencyCode = _data["currencyCode"];
            this.showCount = _data["showCount"];
            this.firstDateISO = _data["firstDateISO"];
            this.lastDateISO = _data["lastDateISO"];
            if (Array.isArray(_data["budgetSummaries"])) {
                this.budgetSummaries = [] as any;
                for (let item of _data["budgetSummaries"])
                    this.budgetSummaries.push(TourSummaryBudgetModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TourSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["currencyCode"] = this.currencyCode;
        data["showCount"] = this.showCount;
        data["firstDateISO"] = this.firstDateISO;
        data["lastDateISO"] = this.lastDateISO;
        if (Array.isArray(this.budgetSummaries)) {
            data["budgetSummaries"] = [];
            for (let item of this.budgetSummaries)
                data["budgetSummaries"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITourSummaryModel {
    id: string;
    name?: string | undefined;
    currencyCode?: string | undefined;
    showCount: number;
    firstDateISO?: string | undefined;
    lastDateISO?: string | undefined;
    budgetSummaries?: TourSummaryBudgetModel[] | undefined;
}

export class TourSummaryBudgetModel implements ITourSummaryBudgetModel {
    showCount: number;
    firstDateISO?: string | undefined;
    lastDateISO?: string | undefined;

    constructor(data?: ITourSummaryBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showCount = _data["showCount"];
            this.firstDateISO = _data["firstDateISO"];
            this.lastDateISO = _data["lastDateISO"];
        }
    }

    static fromJS(data: any): TourSummaryBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourSummaryBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showCount"] = this.showCount;
        data["firstDateISO"] = this.firstDateISO;
        data["lastDateISO"] = this.lastDateISO;
        return data; 
    }
}

export interface ITourSummaryBudgetModel {
    showCount: number;
    firstDateISO?: string | undefined;
    lastDateISO?: string | undefined;
}

export class TourSummaryInfoModel implements ITourSummaryInfoModel {
    hasArchived: boolean;
    tours?: TourSummaryModel[] | undefined;

    constructor(data?: ITourSummaryInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasArchived = _data["hasArchived"];
            if (Array.isArray(_data["tours"])) {
                this.tours = [] as any;
                for (let item of _data["tours"])
                    this.tours.push(TourSummaryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TourSummaryInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourSummaryInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasArchived"] = this.hasArchived;
        if (Array.isArray(this.tours)) {
            data["tours"] = [];
            for (let item of this.tours)
                data["tours"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITourSummaryInfoModel {
    hasArchived: boolean;
    tours?: TourSummaryModel[] | undefined;
}

export class TourReportAvailabilityModel implements ITourReportAvailabilityModel {
    tourDashboard: boolean;
    profitLoss: boolean;
    tourBudgetReport: boolean;

    constructor(data?: ITourReportAvailabilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tourDashboard = _data["tourDashboard"];
            this.profitLoss = _data["profitLoss"];
            this.tourBudgetReport = _data["tourBudgetReport"];
        }
    }

    static fromJS(data: any): TourReportAvailabilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourReportAvailabilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tourDashboard"] = this.tourDashboard;
        data["profitLoss"] = this.profitLoss;
        data["tourBudgetReport"] = this.tourBudgetReport;
        return data; 
    }
}

export interface ITourReportAvailabilityModel {
    tourDashboard: boolean;
    profitLoss: boolean;
    tourBudgetReport: boolean;
}

export class TransactionShowAllocationsModel implements ITransactionShowAllocationsModel {
    transaction?: TransactionModel | undefined;
    showAllocations?: TransactionShowAllocationModel[] | undefined;

    constructor(data?: ITransactionShowAllocationsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transaction = _data["transaction"] ? TransactionModel.fromJS(_data["transaction"]) : <any>undefined;
            if (Array.isArray(_data["showAllocations"])) {
                this.showAllocations = [] as any;
                for (let item of _data["showAllocations"])
                    this.showAllocations.push(TransactionShowAllocationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionShowAllocationsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionShowAllocationsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        if (Array.isArray(this.showAllocations)) {
            data["showAllocations"] = [];
            for (let item of this.showAllocations)
                data["showAllocations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITransactionShowAllocationsModel {
    transaction?: TransactionModel | undefined;
    showAllocations?: TransactionShowAllocationModel[] | undefined;
}

export class TransactionShowAllocationModel implements ITransactionShowAllocationModel {
    showId: string;
    transactionId: string;
    amount: number;

    constructor(data?: ITransactionShowAllocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showId = _data["showId"];
            this.transactionId = _data["transactionId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): TransactionShowAllocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionShowAllocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showId"] = this.showId;
        data["transactionId"] = this.transactionId;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface ITransactionShowAllocationModel {
    showId: string;
    transactionId: string;
    amount: number;
}

export class ShowIncomeRatios implements IShowIncomeRatios {
    tourIncome?: { [key: string]: number; } | undefined;
    merchIncome?: { [key: string]: number; } | undefined;

    constructor(data?: IShowIncomeRatios) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["tourIncome"]) {
                this.tourIncome = {} as any;
                for (let key in _data["tourIncome"]) {
                    if (_data["tourIncome"].hasOwnProperty(key))
                        this.tourIncome[key] = _data["tourIncome"][key];
                }
            }
            if (_data["merchIncome"]) {
                this.merchIncome = {} as any;
                for (let key in _data["merchIncome"]) {
                    if (_data["merchIncome"].hasOwnProperty(key))
                        this.merchIncome[key] = _data["merchIncome"][key];
                }
            }
        }
    }

    static fromJS(data: any): ShowIncomeRatios {
        data = typeof data === 'object' ? data : {};
        let result = new ShowIncomeRatios();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.tourIncome) {
            data["tourIncome"] = {};
            for (let key in this.tourIncome) {
                if (this.tourIncome.hasOwnProperty(key))
                    data["tourIncome"][key] = this.tourIncome[key];
            }
        }
        if (this.merchIncome) {
            data["merchIncome"] = {};
            for (let key in this.merchIncome) {
                if (this.merchIncome.hasOwnProperty(key))
                    data["merchIncome"][key] = this.merchIncome[key];
            }
        }
        return data; 
    }
}

export interface IShowIncomeRatios {
    tourIncome?: { [key: string]: number; } | undefined;
    merchIncome?: { [key: string]: number; } | undefined;
}

export class TransactionShowAllocationsUpdateModel implements ITransactionShowAllocationsUpdateModel {
    transactionId: string;
    calculation: AllocationCalculationType;
    allocations?: TransactionShowAllocationUpdateModel[] | undefined;

    constructor(data?: ITransactionShowAllocationsUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.calculation = _data["calculation"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations.push(TransactionShowAllocationUpdateModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionShowAllocationsUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionShowAllocationsUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["calculation"] = this.calculation;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITransactionShowAllocationsUpdateModel {
    transactionId: string;
    calculation: AllocationCalculationType;
    allocations?: TransactionShowAllocationUpdateModel[] | undefined;
}

export class TransactionShowAllocationUpdateModel implements ITransactionShowAllocationUpdateModel {
    showId: string;
    amount: number;

    constructor(data?: ITransactionShowAllocationUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showId = _data["showId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): TransactionShowAllocationUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionShowAllocationUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showId"] = this.showId;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface ITransactionShowAllocationUpdateModel {
    showId: string;
    amount: number;
}

export class SubCategoryBudgetModel implements ISubCategoryBudgetModel {
    key?: SubCategoryKey | undefined;
    budgetedAmount: number;

    constructor(data?: ISubCategoryBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? SubCategoryKey.fromJS(_data["key"]) : <any>undefined;
            this.budgetedAmount = _data["budgetedAmount"];
        }
    }

    static fromJS(data: any): SubCategoryBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : <any>undefined;
        data["budgetedAmount"] = this.budgetedAmount;
        return data; 
    }
}

export interface ISubCategoryBudgetModel {
    key?: SubCategoryKey | undefined;
    budgetedAmount: number;
}

export class SubCategoryKey implements ISubCategoryKey {
    category?: string | undefined;
    subCategory?: string | undefined;
    currencyCode?: string | undefined;

    constructor(data?: ISubCategoryKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.subCategory = _data["subCategory"];
            this.currencyCode = _data["currencyCode"];
        }
    }

    static fromJS(data: any): SubCategoryKey {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["subCategory"] = this.subCategory;
        data["currencyCode"] = this.currencyCode;
        return data; 
    }
}

export interface ISubCategoryKey {
    category?: string | undefined;
    subCategory?: string | undefined;
    currencyCode?: string | undefined;
}

export class ActualsCommissionModel implements IActualsCommissionModel {
    id: string;
    subcategory?: string | undefined;
    notes?: string | undefined;
    ratePercentage: number;
    sequence: number;
    generateTransaction: boolean;
    commissionableShowIncome?: ActualsCommissionShowIncomeModel[] | undefined;
    costCategoryDeductions?: ActualsCommissionCategoryDeductionModel[] | undefined;
    fromPresetId?: string | undefined;
    originalPresetId?: string | undefined;

    constructor(data?: IActualsCommissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subcategory = _data["subcategory"];
            this.notes = _data["notes"];
            this.ratePercentage = _data["ratePercentage"];
            this.sequence = _data["sequence"];
            this.generateTransaction = _data["generateTransaction"];
            if (Array.isArray(_data["commissionableShowIncome"])) {
                this.commissionableShowIncome = [] as any;
                for (let item of _data["commissionableShowIncome"])
                    this.commissionableShowIncome.push(ActualsCommissionShowIncomeModel.fromJS(item));
            }
            if (Array.isArray(_data["costCategoryDeductions"])) {
                this.costCategoryDeductions = [] as any;
                for (let item of _data["costCategoryDeductions"])
                    this.costCategoryDeductions.push(ActualsCommissionCategoryDeductionModel.fromJS(item));
            }
            this.fromPresetId = _data["fromPresetId"];
            this.originalPresetId = _data["originalPresetId"];
        }
    }

    static fromJS(data: any): ActualsCommissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subcategory"] = this.subcategory;
        data["notes"] = this.notes;
        data["ratePercentage"] = this.ratePercentage;
        data["sequence"] = this.sequence;
        data["generateTransaction"] = this.generateTransaction;
        if (Array.isArray(this.commissionableShowIncome)) {
            data["commissionableShowIncome"] = [];
            for (let item of this.commissionableShowIncome)
                data["commissionableShowIncome"].push(item.toJSON());
        }
        if (Array.isArray(this.costCategoryDeductions)) {
            data["costCategoryDeductions"] = [];
            for (let item of this.costCategoryDeductions)
                data["costCategoryDeductions"].push(item.toJSON());
        }
        data["fromPresetId"] = this.fromPresetId;
        data["originalPresetId"] = this.originalPresetId;
        return data; 
    }
}

export interface IActualsCommissionModel {
    id: string;
    subcategory?: string | undefined;
    notes?: string | undefined;
    ratePercentage: number;
    sequence: number;
    generateTransaction: boolean;
    commissionableShowIncome?: ActualsCommissionShowIncomeModel[] | undefined;
    costCategoryDeductions?: ActualsCommissionCategoryDeductionModel[] | undefined;
    fromPresetId?: string | undefined;
    originalPresetId?: string | undefined;
}

export class ActualsCommissionShowIncomeModel implements IActualsCommissionShowIncomeModel {
    showId: string;
    performanceIncome: boolean;
    subCategoriesSelection: ActualsCommissionsSubCategoriesSelectEnum;
    otherSubcategories?: string[] | undefined;

    constructor(data?: IActualsCommissionShowIncomeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showId = _data["showId"];
            this.performanceIncome = _data["performanceIncome"];
            this.subCategoriesSelection = _data["subCategoriesSelection"];
            if (Array.isArray(_data["otherSubcategories"])) {
                this.otherSubcategories = [] as any;
                for (let item of _data["otherSubcategories"])
                    this.otherSubcategories.push(item);
            }
        }
    }

    static fromJS(data: any): ActualsCommissionShowIncomeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionShowIncomeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showId"] = this.showId;
        data["performanceIncome"] = this.performanceIncome;
        data["subCategoriesSelection"] = this.subCategoriesSelection;
        if (Array.isArray(this.otherSubcategories)) {
            data["otherSubcategories"] = [];
            for (let item of this.otherSubcategories)
                data["otherSubcategories"].push(item);
        }
        return data; 
    }
}

export interface IActualsCommissionShowIncomeModel {
    showId: string;
    performanceIncome: boolean;
    subCategoriesSelection: ActualsCommissionsSubCategoriesSelectEnum;
    otherSubcategories?: string[] | undefined;
}

export enum ActualsCommissionsSubCategoriesSelectEnum {
    All = 0,
    None = 1,
    Some = 2,
}

export class ActualsCommissionCategoryDeductionModel implements IActualsCommissionCategoryDeductionModel {
    category?: string | undefined;
    subCategoriesSelection: ActualsCommissionsSubCategoriesSelectEnum;
    otherSubcategories?: string[] | undefined;

    constructor(data?: IActualsCommissionCategoryDeductionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.subCategoriesSelection = _data["subCategoriesSelection"];
            if (Array.isArray(_data["otherSubcategories"])) {
                this.otherSubcategories = [] as any;
                for (let item of _data["otherSubcategories"])
                    this.otherSubcategories.push(item);
            }
        }
    }

    static fromJS(data: any): ActualsCommissionCategoryDeductionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionCategoryDeductionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["subCategoriesSelection"] = this.subCategoriesSelection;
        if (Array.isArray(this.otherSubcategories)) {
            data["otherSubcategories"] = [];
            for (let item of this.otherSubcategories)
                data["otherSubcategories"].push(item);
        }
        return data; 
    }
}

export interface IActualsCommissionCategoryDeductionModel {
    category?: string | undefined;
    subCategoriesSelection: ActualsCommissionsSubCategoriesSelectEnum;
    otherSubcategories?: string[] | undefined;
}

export class ActualsCommissionDataModel implements IActualsCommissionDataModel {
    showData?: ActualsCommissionShowDataModel[] | undefined;
    commissionSubcategoryNames?: string[] | undefined;
    otherIncomeSubcategoryNames?: string[] | undefined;
    costCategories?: ActualsCommissionCategoryNameDataModel[] | undefined;

    constructor(data?: IActualsCommissionDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["showData"])) {
                this.showData = [] as any;
                for (let item of _data["showData"])
                    this.showData.push(ActualsCommissionShowDataModel.fromJS(item));
            }
            if (Array.isArray(_data["commissionSubcategoryNames"])) {
                this.commissionSubcategoryNames = [] as any;
                for (let item of _data["commissionSubcategoryNames"])
                    this.commissionSubcategoryNames.push(item);
            }
            if (Array.isArray(_data["otherIncomeSubcategoryNames"])) {
                this.otherIncomeSubcategoryNames = [] as any;
                for (let item of _data["otherIncomeSubcategoryNames"])
                    this.otherIncomeSubcategoryNames.push(item);
            }
            if (Array.isArray(_data["costCategories"])) {
                this.costCategories = [] as any;
                for (let item of _data["costCategories"])
                    this.costCategories.push(ActualsCommissionCategoryNameDataModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActualsCommissionDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.showData)) {
            data["showData"] = [];
            for (let item of this.showData)
                data["showData"].push(item.toJSON());
        }
        if (Array.isArray(this.commissionSubcategoryNames)) {
            data["commissionSubcategoryNames"] = [];
            for (let item of this.commissionSubcategoryNames)
                data["commissionSubcategoryNames"].push(item);
        }
        if (Array.isArray(this.otherIncomeSubcategoryNames)) {
            data["otherIncomeSubcategoryNames"] = [];
            for (let item of this.otherIncomeSubcategoryNames)
                data["otherIncomeSubcategoryNames"].push(item);
        }
        if (Array.isArray(this.costCategories)) {
            data["costCategories"] = [];
            for (let item of this.costCategories)
                data["costCategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IActualsCommissionDataModel {
    showData?: ActualsCommissionShowDataModel[] | undefined;
    commissionSubcategoryNames?: string[] | undefined;
    otherIncomeSubcategoryNames?: string[] | undefined;
    costCategories?: ActualsCommissionCategoryNameDataModel[] | undefined;
}

export class ActualsCommissionShowDataModel implements IActualsCommissionShowDataModel {
    id: string;
    dateISO?: string | undefined;
    venue?: VenueModel | undefined;
    incomeCategoryData?: ActualsCommissionCategoryDataModel[] | undefined;
    costCategoryData?: ActualsCommissionCategoryDataModel[] | undefined;
    existingCommissionTransactions?: { [key: string]: number; } | undefined;

    constructor(data?: IActualsCommissionShowDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateISO = _data["dateISO"];
            this.venue = _data["venue"] ? VenueModel.fromJS(_data["venue"]) : <any>undefined;
            if (Array.isArray(_data["incomeCategoryData"])) {
                this.incomeCategoryData = [] as any;
                for (let item of _data["incomeCategoryData"])
                    this.incomeCategoryData.push(ActualsCommissionCategoryDataModel.fromJS(item));
            }
            if (Array.isArray(_data["costCategoryData"])) {
                this.costCategoryData = [] as any;
                for (let item of _data["costCategoryData"])
                    this.costCategoryData.push(ActualsCommissionCategoryDataModel.fromJS(item));
            }
            if (_data["existingCommissionTransactions"]) {
                this.existingCommissionTransactions = {} as any;
                for (let key in _data["existingCommissionTransactions"]) {
                    if (_data["existingCommissionTransactions"].hasOwnProperty(key))
                        this.existingCommissionTransactions[key] = _data["existingCommissionTransactions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ActualsCommissionShowDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionShowDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateISO"] = this.dateISO;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        if (Array.isArray(this.incomeCategoryData)) {
            data["incomeCategoryData"] = [];
            for (let item of this.incomeCategoryData)
                data["incomeCategoryData"].push(item.toJSON());
        }
        if (Array.isArray(this.costCategoryData)) {
            data["costCategoryData"] = [];
            for (let item of this.costCategoryData)
                data["costCategoryData"].push(item.toJSON());
        }
        if (this.existingCommissionTransactions) {
            data["existingCommissionTransactions"] = {};
            for (let key in this.existingCommissionTransactions) {
                if (this.existingCommissionTransactions.hasOwnProperty(key))
                    data["existingCommissionTransactions"][key] = this.existingCommissionTransactions[key];
            }
        }
        return data; 
    }
}

export interface IActualsCommissionShowDataModel {
    id: string;
    dateISO?: string | undefined;
    venue?: VenueModel | undefined;
    incomeCategoryData?: ActualsCommissionCategoryDataModel[] | undefined;
    costCategoryData?: ActualsCommissionCategoryDataModel[] | undefined;
    existingCommissionTransactions?: { [key: string]: number; } | undefined;
}

export class ActualsCommissionCategoryDataModel implements IActualsCommissionCategoryDataModel {
    category?: string | undefined;
    amount: number;
    subcategoryAmounts?: ActualsCommissionSubcategoryAmountModel[] | undefined;

    constructor(data?: IActualsCommissionCategoryDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["subcategoryAmounts"])) {
                this.subcategoryAmounts = [] as any;
                for (let item of _data["subcategoryAmounts"])
                    this.subcategoryAmounts.push(ActualsCommissionSubcategoryAmountModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActualsCommissionCategoryDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionCategoryDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["amount"] = this.amount;
        if (Array.isArray(this.subcategoryAmounts)) {
            data["subcategoryAmounts"] = [];
            for (let item of this.subcategoryAmounts)
                data["subcategoryAmounts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IActualsCommissionCategoryDataModel {
    category?: string | undefined;
    amount: number;
    subcategoryAmounts?: ActualsCommissionSubcategoryAmountModel[] | undefined;
}

export class ActualsCommissionSubcategoryAmountModel implements IActualsCommissionSubcategoryAmountModel {
    subcategory?: string | undefined;
    amount: number;

    constructor(data?: IActualsCommissionSubcategoryAmountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subcategory = _data["subcategory"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ActualsCommissionSubcategoryAmountModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionSubcategoryAmountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subcategory"] = this.subcategory;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IActualsCommissionSubcategoryAmountModel {
    subcategory?: string | undefined;
    amount: number;
}

export class ActualsCommissionCategoryNameDataModel implements IActualsCommissionCategoryNameDataModel {
    categoryName?: string | undefined;
    subcategoryNames?: string[] | undefined;

    constructor(data?: IActualsCommissionCategoryNameDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
            if (Array.isArray(_data["subcategoryNames"])) {
                this.subcategoryNames = [] as any;
                for (let item of _data["subcategoryNames"])
                    this.subcategoryNames.push(item);
            }
        }
    }

    static fromJS(data: any): ActualsCommissionCategoryNameDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionCategoryNameDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        if (Array.isArray(this.subcategoryNames)) {
            data["subcategoryNames"] = [];
            for (let item of this.subcategoryNames)
                data["subcategoryNames"].push(item);
        }
        return data; 
    }
}

export interface IActualsCommissionCategoryNameDataModel {
    categoryName?: string | undefined;
    subcategoryNames?: string[] | undefined;
}

export class ActualsCommissionTransactionCreateModel implements IActualsCommissionTransactionCreateModel {
    subcategory?: string | undefined;
    notes?: string | undefined;
    showAmounts?: ActualsCommissionAdjustmentShowAmountModel[] | undefined;
    isAdjustment: boolean;

    constructor(data?: IActualsCommissionTransactionCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subcategory = _data["subcategory"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["showAmounts"])) {
                this.showAmounts = [] as any;
                for (let item of _data["showAmounts"])
                    this.showAmounts.push(ActualsCommissionAdjustmentShowAmountModel.fromJS(item));
            }
            this.isAdjustment = _data["isAdjustment"];
        }
    }

    static fromJS(data: any): ActualsCommissionTransactionCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionTransactionCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subcategory"] = this.subcategory;
        data["notes"] = this.notes;
        if (Array.isArray(this.showAmounts)) {
            data["showAmounts"] = [];
            for (let item of this.showAmounts)
                data["showAmounts"].push(item.toJSON());
        }
        data["isAdjustment"] = this.isAdjustment;
        return data; 
    }
}

export interface IActualsCommissionTransactionCreateModel {
    subcategory?: string | undefined;
    notes?: string | undefined;
    showAmounts?: ActualsCommissionAdjustmentShowAmountModel[] | undefined;
    isAdjustment: boolean;
}

export class ActualsCommissionAdjustmentShowAmountModel implements IActualsCommissionAdjustmentShowAmountModel {
    showId: string;
    amount: number;

    constructor(data?: IActualsCommissionAdjustmentShowAmountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showId = _data["showId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ActualsCommissionAdjustmentShowAmountModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionAdjustmentShowAmountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showId"] = this.showId;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IActualsCommissionAdjustmentShowAmountModel {
    showId: string;
    amount: number;
}

export class CategoryTotalModel implements ICategoryTotalModel {
    category?: string | undefined;
    currency?: string | undefined;
    total: number;
    transactionType: TransactionType;

    constructor(data?: ICategoryTotalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.currency = _data["currency"];
            this.total = _data["total"];
            this.transactionType = _data["transactionType"];
        }
    }

    static fromJS(data: any): CategoryTotalModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTotalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["currency"] = this.currency;
        data["total"] = this.total;
        data["transactionType"] = this.transactionType;
        return data; 
    }
}

export interface ICategoryTotalModel {
    category?: string | undefined;
    currency?: string | undefined;
    total: number;
    transactionType: TransactionType;
}

export class SubCategoryTotalModel implements ISubCategoryTotalModel {
    key?: SubCategoryKey | undefined;
    total: number;
    transactionType: TransactionType;

    constructor(data?: ISubCategoryTotalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? SubCategoryKey.fromJS(_data["key"]) : <any>undefined;
            this.total = _data["total"];
            this.transactionType = _data["transactionType"];
        }
    }

    static fromJS(data: any): SubCategoryTotalModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubCategoryTotalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : <any>undefined;
        data["total"] = this.total;
        data["transactionType"] = this.transactionType;
        return data; 
    }
}

export interface ISubCategoryTotalModel {
    key?: SubCategoryKey | undefined;
    total: number;
    transactionType: TransactionType;
}

export class TourStatsModel implements ITourStatsModel {
    numberOfShows: number;
    income: number;
    costs: number;
    ticketsSold: number;
    currencyCode?: string | undefined;
    profit: number;

    constructor(data?: ITourStatsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfShows = _data["numberOfShows"];
            this.income = _data["income"];
            this.costs = _data["costs"];
            this.ticketsSold = _data["ticketsSold"];
            this.currencyCode = _data["currencyCode"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): TourStatsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourStatsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfShows"] = this.numberOfShows;
        data["income"] = this.income;
        data["costs"] = this.costs;
        data["ticketsSold"] = this.ticketsSold;
        data["currencyCode"] = this.currencyCode;
        data["profit"] = this.profit;
        return data; 
    }
}

export interface ITourStatsModel {
    numberOfShows: number;
    income: number;
    costs: number;
    ticketsSold: number;
    currencyCode?: string | undefined;
    profit: number;
}

export class TourSetupProgressModel implements ITourSetupProgressModel {
    hasShows: boolean;
    transactionsUploaded: boolean;
    categoriesAllocated: boolean;
    incomeAllocationsAddUp: boolean;
    costAllocationsAddUp: boolean;

    constructor(data?: ITourSetupProgressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasShows = _data["hasShows"];
            this.transactionsUploaded = _data["transactionsUploaded"];
            this.categoriesAllocated = _data["categoriesAllocated"];
            this.incomeAllocationsAddUp = _data["incomeAllocationsAddUp"];
            this.costAllocationsAddUp = _data["costAllocationsAddUp"];
        }
    }

    static fromJS(data: any): TourSetupProgressModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourSetupProgressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasShows"] = this.hasShows;
        data["transactionsUploaded"] = this.transactionsUploaded;
        data["categoriesAllocated"] = this.categoriesAllocated;
        data["incomeAllocationsAddUp"] = this.incomeAllocationsAddUp;
        data["costAllocationsAddUp"] = this.costAllocationsAddUp;
        return data; 
    }
}

export interface ITourSetupProgressModel {
    hasShows: boolean;
    transactionsUploaded: boolean;
    categoriesAllocated: boolean;
    incomeAllocationsAddUp: boolean;
    costAllocationsAddUp: boolean;
}

export class ActualsCommissionsReportModel implements IActualsCommissionsReportModel {
    commissions?: ActualsCommissionModel[] | undefined;
    data?: ActualsCommissionDataModel | undefined;
    tourReport?: TourMegaReportModel | undefined;

    constructor(data?: IActualsCommissionsReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["commissions"])) {
                this.commissions = [] as any;
                for (let item of _data["commissions"])
                    this.commissions.push(ActualsCommissionModel.fromJS(item));
            }
            this.data = _data["data"] ? ActualsCommissionDataModel.fromJS(_data["data"]) : <any>undefined;
            this.tourReport = _data["tourReport"] ? TourMegaReportModel.fromJS(_data["tourReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActualsCommissionsReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActualsCommissionsReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commissions)) {
            data["commissions"] = [];
            for (let item of this.commissions)
                data["commissions"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["tourReport"] = this.tourReport ? this.tourReport.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IActualsCommissionsReportModel {
    commissions?: ActualsCommissionModel[] | undefined;
    data?: ActualsCommissionDataModel | undefined;
    tourReport?: TourMegaReportModel | undefined;
}

export class ArtistUserModel implements IArtistUserModel {
    id?: string | undefined;
    name?: string | undefined;
    role: ArtistUserRole;
    pictureUrl?: string | undefined;

    constructor(data?: IArtistUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.role = _data["role"];
            this.pictureUrl = _data["pictureUrl"];
        }
    }

    static fromJS(data: any): ArtistUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["role"] = this.role;
        data["pictureUrl"] = this.pictureUrl;
        return data; 
    }
}

export interface IArtistUserModel {
    id?: string | undefined;
    name?: string | undefined;
    role: ArtistUserRole;
    pictureUrl?: string | undefined;
}

export class UserArtistInviteSummaryModel implements IUserArtistInviteSummaryModel {
    token?: string | undefined;
    recipientName?: string | undefined;
    sentDateISOUtc?: string | undefined;
    role: ArtistUserRole;
    expiresUtc?: string | undefined;
    isExpired: boolean;
    acceptanceUrl?: string | undefined;

    constructor(data?: IUserArtistInviteSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.recipientName = _data["recipientName"];
            this.sentDateISOUtc = _data["sentDateISOUtc"];
            this.role = _data["role"];
            this.expiresUtc = _data["expiresUtc"];
            this.isExpired = _data["isExpired"];
            this.acceptanceUrl = _data["acceptanceUrl"];
        }
    }

    static fromJS(data: any): UserArtistInviteSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserArtistInviteSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["recipientName"] = this.recipientName;
        data["sentDateISOUtc"] = this.sentDateISOUtc;
        data["role"] = this.role;
        data["expiresUtc"] = this.expiresUtc;
        data["isExpired"] = this.isExpired;
        data["acceptanceUrl"] = this.acceptanceUrl;
        return data; 
    }
}

export interface IUserArtistInviteSummaryModel {
    token?: string | undefined;
    recipientName?: string | undefined;
    sentDateISOUtc?: string | undefined;
    role: ArtistUserRole;
    expiresUtc?: string | undefined;
    isExpired: boolean;
    acceptanceUrl?: string | undefined;
}

export class UserInvitationCreateModel implements IUserInvitationCreateModel {
    recipientName?: string | undefined;
    role: ArtistUserRole;
    redirectUrl?: string | undefined;

    constructor(data?: IUserInvitationCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientName = _data["recipientName"];
            this.role = _data["role"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): UserInvitationCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInvitationCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientName"] = this.recipientName;
        data["role"] = this.role;
        data["redirectUrl"] = this.redirectUrl;
        return data; 
    }
}

export interface IUserInvitationCreateModel {
    recipientName?: string | undefined;
    role: ArtistUserRole;
    redirectUrl?: string | undefined;
}

export enum InviteAcceptStatus {
    SUCCESS = 0,
    NOTFOUND = 1,
    EXPIRED = 2,
    ALREADYACCEPTED = 3,
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}